/*
================================================================================
  KIT LAINE — script du bloc vitrine
  Version 1.0 — passe 58
================================================================================

  À poser dans le thème sous assets/lat-kit-laine.js, à côté de
  snippets/lat-kit-laine.liquid qui le charge et lui fournit ses données :
  le metafield du modèle, les produits laine préchargés, les chaînes
  traduites. Ce fichier ne contient pas de Liquid et n'en attend pas.

  POURQUOI UN FICHIER À PART — passe 51
  -------------------------------------
  Écrit en ligne dans le snippet, ce script partait dans le HTML de chaque
  fiche modèle : 127 Ko, dont 42 % de commentaires, retéléchargés à chaque
  visite et jamais mis en cache. Servi depuis assets/, il est minifié par
  le CDN de Shopify et gardé par le navigateur d'une fiche à l'autre. Les
  commentaires restent pour qui lit le dépôt ; aucun visiteur ne les
  télécharge plus.

  ES5 STRICT — et ce n'est plus seulement une affaire de navigateurs :
  Shopify ne minifie que le JavaScript dont la syntaxe est de l'ES5
  valide. Au premier `const` ou à la première fonction fléchée, il
  servirait ce fichier tel quel, commentaires compris.

  LES TROIS FICHIERS VONT ENSEMBLE
  --------------------------------
  Snippet, script et feuille de style portent le même numéro de passe.
  Le script compare les trois au chargement et avertit en console si l'un
  a vieilli — voir `verifierPasse()`. `verifie-syntaxe.js` refuse de passer
  si ces numéros ne suivent plus le CHANGELOG.
================================================================================
*/
(function () {
  'use strict';

  /* ==========================================================
     Repli de traduction. Utilisé si les clés de locale sont
     absentes — ce qui arrive si l'éditeur de langue de l'admin
     régénère le fichier (il porte l'avertissement « auto-generated,
     may be overwritten »).
     ========================================================== */
  var FALLBACK = {
    format:            'Format',
    format_pdf:        'PDF à télécharger',
    format_papier:     'Livret papier',
    format_pdf_papier: 'PDF et livret papier',
    variante:     'Langue du modèle',
    taille:       'Taille',
    taille_choix: 'Choisissez une taille',
    qualite:      'Qualité de laine',
    colorways:    'Coloris suggérés',
    pelotes:      'pelotes',
    pelote:       'pelote',
    total:        'Total laine',
    ajouter:      'Ajouter le kit au panier',
    ajout_cours:  'Ajout en cours…',
    ajoute:       'Ajouté au panier',
    erreur:       'L\u2019ajout au panier a échoué. Merci de réessayer.',
    choix:        'Choix',
    indispo:      'Épuisé',
    voir_panier:  'Voir le panier',
    stock_court:  'Stock insuffisant',
    stock_titre:  'Stock insuffisant pour cette taille',
    stock_aide:   'Choisissez un autre coloris, ou une autre taille.',
    indispo_titre: 'Ce kit est momentanément incomplet',
    indispo_aide: 'Une des laines nécessaires n\u2019est plus disponible. Merci de nous contacter.',
    total_modele: 'Modèle',
    total_laine:  'Laine',
    total_kit:    'Total',
    deja_panier:  'déjà au panier',
    obligatoire:  'Ce modèle est vendu uniquement avec la laine nécessaire à sa réalisation.',
    taxes_ttc:    'TVA incluse',
    taxes_ht:     'Taxes calculées à la commande',
    securite:     'Ajouter une pelote de sécurité',
    securite_dont: 'dont 1 de sécurité',
    rupture_titre: 'Modèle momentanément indisponible.',
    rupture_aide: 'La laine reste indiquée pour préparer votre projet. L\u2019ajout du kit au panier reviendra avec le modèle ; l\u2019alerte de retour en stock est disponible sur cette page.',
    mode: 'Formule',
    mode_seul: 'Le modèle seul',
    mode_kit: 'Le modèle et sa laine',
    ajouter_modele: 'Ajouter le modèle au panier',
    stock_suffisant: 'suffisant en',
    stock_sans_securite: 'suffisant sans la pelote de sécurité',
    format_variante: 'Format et langue du modèle',
    a_partir_de: 'à partir de',
    prix_kit: 'Kit complet',
    colorway_modifie: 'modifié',
    colorway_complete: 'complété',
    inclus: 'Inclus dans le kit',
    offert: 'Offert',
    colorways_imposes: 'Coloris du kit'
  };

  /* ==========================================================
     Décodage des entités HTML

     Le filtre `t` de Shopify échappe les traductions : une apostrophe
     arrive sous la forme &#39;, une esperluette sous &amp;. Comme le
     rendu se fait par textContent — qui n'interprète pas le HTML —
     l'entité s'afficherait telle quelle :

       « I&#39;d like to buy the yarn »
       « Couleur d&#39;accent »

     Un textarea détaché fait le décodage : son contenu est analysé
     comme du texte, jamais exécuté. C'est la méthode sûre.

     N'est appliqué qu'aux chaînes issues de `t`. Le texte du metafield,
     lui, n'est pas échappé : le décoder abîmerait une esperluette
     voulue.
     ========================================================== */
  var deco = null;
  function deHtml(s) {
    if (typeof s !== 'string' || s.indexOf('&') === -1) return s;
    if (!deco) deco = document.createElement('textarea');
    deco.innerHTML = s;
    return deco.value;
  }

  function lire(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent || 'null'); } catch (e) { return null; }
  }

  function el(tag, cls, txt) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (txt != null) n.textContent = txt;
    return n;
  }

  function esc(s) {
    return String(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  }

  /* ==========================================================
     Normalisation — SOURCE UNIQUE DE VÉRITÉ pour la forme des
     clés. Liquid émet les titres bruts ; tout passe par ici.
     ========================================================== */
  function norm(s) {
    return String(s || '').trim().toLowerCase()
      .replace(/\s*\([^)]*\)\s*$/, '')
      .replace(/['\u2018\u2019`"\u201C\u201D]/g, '')
      .trim();
  }

  /* ==========================================================
     Code coloris numérique de tête.

       "1099-Noir"                 -> "1099"   (Sandnes Garn)
       "3001 Light Moorit"         -> "3001"   (Fjallalopi)
       "p1430 Carmine Red Heather" -> "1430"   (Plötulopi)
       "Natural"                   -> ""

     Sert de point d'ancrage stable entre langues : les libellés
     sont traduits ("Noir" / "Black"), le code du fabricant ne
     l'est pas.

     Deux tolérances, tirées de catalogues réels :

     - Préfixe de une ou deux lettres. Ístex écrit "p1430" pour
       Plötulopi. Seuls les chiffres sont retenus, si bien qu'un
       catalogue mêlant "9103" et "p9102" — ce qui arrive — reste
       cohérent.

     - Fin de chaîne acceptée : "p0001" peut constituer tout le
       titre, sans séparateur derrière.

     Trois chiffres minimum : un "1" isolé collisionnerait avec
     bien trop de variantes.
     ========================================================== */
  function codeColoris(s) {
    var m = String(s || '').match(/(?:^|[\s\-])[a-z]{0,2}(\d{3,})(?=[-\s]|$)/i);
    return m ? m[1] : '';
  }

  /* ==========================================================
     Résolution d'un coloris dans la liste des variantes.

     Cascade, du plus strict au plus permissif :
       1. Correspondance exacte normalisée
       2. Retrait d'un préfixe "MARQUE - " puis nouvel essai
       3. Suffixe sur frontière de mot (-, espace, début)
       4. Sous-chaîne, à partir de 4 caractères
       5. Code coloris numérique

     Reprise de la cascade éprouvée du snippet swatches v3.3.
     L'étape 5 ne peut jamais primer sur une correspondance
     textuelle, et n'accepte pas les codes ambigus.
     ========================================================== */
  var MIN_FLOU = 4;

  /* ==========================================================
     Résolution mise en cache — passe 54

     La cascade ci-dessous est pure : même liste de variantes, même
     valeur, même réponse. Elle est pourtant rejouée sans cesse — le
     plancher d'un kit à coloris imposés la relance pour chaque
     taille, chaque kit et chaque couleur, deux fois par rendu. Sur un
     jacquard à dix couleurs, huit kits et huit tailles, le premier
     rendu prenait 301 ms sur un mobile moyen, dont l'essentiel quand
     un coloris est désigné par son seul code : il traverse alors les
     cinq étapes. Mis en cache : 37 ms.

     Sûr parce que la liste des variantes d'un produit ne change pas
     pendant la vie de la page — le bloc la lit une fois dans le
     payload et n'y touche plus. La WeakMap rattache chaque cache à sa
     liste, et le laisse partir avec elle. La clé porte le type de la
     valeur : 0 et "0" ne se résolvent pas de la même façon.
     ========================================================== */
  var cacheResolution = typeof WeakMap === 'function' ? new WeakMap() : null;

  function trouverVariante(variantes, valeur) {
    if (!cacheResolution || !variantes || typeof variantes !== 'object') {
      return resoudreVariante(variantes, valeur);
    }
    var parValeur = cacheResolution.get(variantes);
    if (!parValeur) {
      parValeur = Object.create(null);
      cacheResolution.set(variantes, parValeur);
    }
    var cle = typeof valeur + ':' + String(valeur);
    if (!(cle in parValeur)) parValeur[cle] = resoudreVariante(variantes, valeur);
    return parValeur[cle];
  }

  function resoudreVariante(variantes, valeur) {
    if (!variantes || !variantes.length) return null;

    /* 0. Identifiant de variante.
       Un colorway peut désigner un coloris par son id Shopify plutôt
       que par son titre. C'est la seule référence totalement insensible
       à la langue, donc la réponse définitive pour les laines dont les
       coloris n'ont pas de code numérique (Love Story : « Moss green »,
       « Volcanic red »…) sur une boutique dont les variantes sont
       traduites.

       Les id Shopify comptent une douzaine de chiffres au moins ; un
       code coloris en compte trois à cinq. Le seuil de 10 évite donc
       toute confusion avec un code. */
    var brut = String(valeur == null ? '' : valeur).trim();
    if (/^\d{10,}$/.test(brut)) {
      var cible = parseInt(brut, 10);
      for (var k = 0; k < variantes.length; k++) {
        if (variantes[k].id === cible) return variantes[k];
      }
      return null;   // id fourni mais introuvable : ne pas deviner
    }

    var cle = norm(valeur);
    if (!cle) return null;

    var i, v;

    // 1. exact
    for (i = 0; i < variantes.length; i++) {
      if (norm(variantes[i].titre) === cle) return variantes[i];
    }

    // 2. sans préfixe
    var sansPrefixe = cle.replace(/^[^-]+\s*-\s*/, '').trim();
    if (sansPrefixe && sansPrefixe !== cle) {
      for (i = 0; i < variantes.length; i++) {
        if (norm(variantes[i].titre) === sansPrefixe) return variantes[i];
      }
    }

    // 3. suffixe sur frontière, le plus long gagne
    var best = null, bestLen = 0;
    for (i = 0; i < variantes.length; i++) {
      var t = norm(variantes[i].titre);
      if (!t || cle.length < t.length) continue;
      if (cle.slice(-t.length) !== t) continue;
      var bi = cle.length - t.length - 1;
      if ((bi < 0 || /[-\s]/.test(cle.charAt(bi))) && t.length > bestLen) {
        best = variantes[i]; bestLen = t.length;
      }
    }
    if (best) return best;

    // 4. sous-chaîne, longueur plancher
    for (i = 0; i < variantes.length; i++) {
      var u = norm(variantes[i].titre);
      if (!u || u.length < MIN_FLOU) continue;
      if (cle.indexOf(u) !== -1 && u.length > bestLen) {
        best = variantes[i]; bestLen = u.length;
      }
    }
    if (best) return best;

    // 5. code coloris — survit à la traduction du nom
    var code = codeColoris(cle);
    if (code) {
      var trouve = null, ambigu = false;
      for (i = 0; i < variantes.length; i++) {
        if (codeColoris(variantes[i].titre) === code) {
          if (trouve) { ambigu = true; break; }
          trouve = variantes[i];
        }
      }
      if (trouve && !ambigu) return trouve;
    }

    return null;
  }

  /* ==========================================================
     Formatage monétaire. Utilise l'API Shopify si disponible,
     sinon un repli simple. Les prix sont en centimes.
     ========================================================== */
  /* Formatage monétaire.
     Priorité à l'API du thème quand elle existe. Sinon, application du
     `shop.money_format` fourni par Liquid — indispensable sur une boutique
     multi-devises (Shopify Markets), où supposer l'euro serait faux.
     Gère les jetons amount, amount_with_comma_separator,
     amount_no_decimals et leurs variantes.

     Les doubles accolades ne sont jamais écrites littéralement dans ce
     fichier : Liquid les interpréterait comme une balise de sortie,
     y compris à l'intérieur d'une chaîne JavaScript. Elles sont donc
     assemblées à l'exécution. */
  function formaterMontant(centimes, gabarit) {
    var n = centimes / 100;

    function sep(valeur, millier, decimal, decimales) {
      var s = Math.abs(valeur).toFixed(decimales);
      var parts = s.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, millier);
      var out = parts.length > 1 ? parts.join(decimal) : parts[0];
      return (valeur < 0 ? '-' : '') + out;
    }

    return String(gabarit).replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, cle) {
      switch (cle) {
        case 'amount':                          return sep(n, ',', '.', 2);
        case 'amount_no_decimals':              return sep(n, ',', '.', 0);
        case 'amount_with_comma_separator':     return sep(n, '.', ',', 2);
        case 'amount_no_decimals_with_comma_separator': return sep(n, '.', ',', 0);
        case 'amount_with_apostrophe_separator': return sep(n, "'", '.', 2);
        case 'amount_no_decimals_with_space_separator': return sep(n, '\u202F', ',', 0);
        case 'amount_with_space_separator':     return sep(n, '\u202F', ',', 2);
        default:                                return sep(n, ',', '.', 2);
      }
    });
  }

  /* ==========================================================
     Racine des URL de la boutique — passe 53

     `/cart.js` écrit en dur ramène le visiteur à la langue et à la
     devise par défaut de la boutique : la documentation Shopify le
     dit en ces termes, à propos des URL de marché et de langue. Sur
     Icelandic Knitter, servie en /is/ et /en/, l'ajout au panier, sa
     relecture et le lien « Voir le panier » partaient tous vers la
     racine.

     `Shopify.routes.root` porte le préfixe du marché et de la langue
     en cours, barre finale comprise. Il est relu à chaque appel, et
     `/` le remplace s'il manque.
     ========================================================== */
  function racine() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (typeof r === 'string' && r.charAt(r.length - 1) === '/') ? r : '/';
  }

  /* ==========================================================
     Repère de version — passe 51

     Snippet, script et feuille de style sont trois fichiers,
     recopiés à la main dans chaque thème. Rien sur la boutique ne
     signalait qu'une copie avait vieilli : le numéro de passe ne
     se lisait qu'en ouvrant chaque fichier dans l'éditeur de code.
     Le script compare donc les trois au premier bloc rencontré.

     Un écart n'arrête rien — le bloc s'affiche au mieux — mais il
     s'écrit en console, là où l'on regarde quand quelque chose
     cloche.

     La feuille est relue une seconde fois avant d'être déclarée
     absente : dans l'éditeur de thème, un bloc rechargé réinsère
     son <link>, que le navigateur peut ne pas avoir encore
     appliqué au moment où le script le cherche.
     ========================================================== */
  var PASSE = '58';
  var passeVerifiee = false;

  function passeFeuille(bloc) {
    var v = '';
    try {
      v = window.getComputedStyle(bloc).getPropertyValue('--lat-kit-passe');
    } catch (e) { /* navigateur sans variables CSS : rien à comparer */ }
    return String(v || '').trim();
  }

  function verifierPasse(bloc) {
    if (passeVerifiee || !window.console) return;
    passeVerifiee = true;

    function comparer(feuille) {
      var snippet = bloc.getAttribute('data-passe') || '?';
      if (snippet === PASSE && feuille === PASSE) return;
      console.warn('[lat-kit] fichiers de passes différentes — snippet : ' +
        snippet + ', script : ' + PASSE + ', feuille de style : ' +
        (feuille || 'introuvable') + '. Recopier les trois fichiers de la ' +
        'même version (docs/02-deploiement.md § A2).');
    }

    var feuille = passeFeuille(bloc);
    if (feuille) { comparer(feuille); return; }
    setTimeout(function () { comparer(passeFeuille(bloc)); }, 2000);
  }

  /* ==========================================================
     Une instance par conteneur.
     ========================================================== */
  function initBloc(bloc) {
    if (bloc.getAttribute('data-lat-kit-pret') === '1') return;
    bloc.setAttribute('data-lat-kit-pret', '1');
    verifierPasse(bloc);

    var kit = lire(bloc.getAttribute('data-kit-id'));
    var laines = lire(bloc.getAttribute('data-yarn-id')) || {};
    var strBrut = lire(bloc.getAttribute('data-str-id')) || {};

    /* Des tableaux, et non seulement des valeurs qui ont une longueur :
       une chaîne en a une aussi, et `"S,M,L".map` emportait le bloc. */
    if (!kit || !Array.isArray(kit.tailles) || !kit.tailles.length ||
        !Array.isArray(kit.options) || !kit.options.length) {
      bloc.style.display = 'none';
      return;
    }

    /* Quantités : des entiers, quelle que soit la saisie — passe 53.

       Le metafield se remplit à la main, par le générateur, par
       Sidekick ou par import. Une quantité écrite "7" au lieu de 7
       passait tous les contrôles — "7" > 0 est vrai — puis `qteDe()`
       ajoutait la pelote de sécurité par CONCATÉNATION : "7" + 0 donne
       "70". Le client voyait 70 pelotes à 486,50 €, et /cart/add.js
       les recevait ; l'ancre, elle, multipliait et restait juste, si
       bien que le bloc se contredisait.

       Convertir une fois, ici, protège d'un coup la demi-douzaine de
       calculs qui lisent `quantites`. Une valeur qui n'est pas un
       nombre compte pour 0 — le composant n'est pas requis dans cette
       taille, ce qu'un `null` a toujours signifié —, et l'audit la
       signale comme bloquante. Des quantités qui ne sont pas un tableau
       rendent le composant inexploitable : il est écarté, comme l'est
       un tableau de mauvaise longueur. */
    function objet(x) { return !!x && typeof x === 'object'; }
    /* Seuls les objets sont touchés : poser une propriété sur une chaîne
       saisie par erreur lèverait une erreur en mode strict, et
       emporterait le bloc — pire que la donnée fautive elle-même. */
    kit.options.forEach(function (o) {
      if (!objet(o)) return;
      o.composants = Array.isArray(o.composants) ? o.composants.filter(objet) : [];
      o.composants.forEach(function (c) {
        c.quantites = Array.isArray(c.quantites)
          ? c.quantites.map(function (q) { var n = parseInt(q, 10); return isFinite(n) ? n : 0; })
          : null;
      });
    });

    // Chaînes : locale si présente et non vide, sinon repli
    var S = {};
    Object.keys(FALLBACK).forEach(function (k) {
      var v = strBrut[k];
      S[k] = (typeof v === 'string' && v && v.indexOf('translation missing') === -1)
        ? deHtml(v) : FALLBACK[k];
    });

    /* true si les prix affichés incluent la taxe pour ce marché. */
    var taxesIncluses = strBrut._taxes_included === true;


    /* Assemblées plutôt qu'écrites : une double accolade littérale
       serait interprétée par Liquid avant même d'atteindre le
       navigateur, y compris dans une chaîne JavaScript. */
    var OUVR = '{' + '{';
    var FERM = '}' + '}';

    var gabaritMonnaie = (typeof strBrut._money_format === 'string' &&
      strBrut._money_format.indexOf(OUVR) !== -1)
      ? strBrut._money_format
      : OUVR + 'amount_with_comma_separator' + FERM + ' \u20AC';

    /** Montant formaté selon la boutique. */
    function prix(centimes) {
      if (window.Shopify && window.Shopify.formatMoney) {
        try {
          return window.Shopify.formatMoney(
            centimes, window.Shopify.money_format || gabaritMonnaie);
        } catch (e) { /* repli ci-dessous */ }
      }
      return formaterMontant(centimes, gabaritMonnaie);
    }

    /* ---------- Rôles ----------
       Table clé → libellé traduit, produite par Liquid. Vide si le
       catalogue n'utilise que des rôles en texte brut. */
    var rolesTraduits = lire(bloc.getAttribute('data-roles-id')) || {};
    var modeleVariantes = lire(bloc.getAttribute('data-modele-id')) || {};

    /* Images de la fiche modèle, dans leur ordre de galerie. Sert à
       retrouver la photo d'un colorway.

       Vide de deux façons, sans que le rendu s'en aperçoive : le
       modèle n'a aucune photo, ou — depuis la passe 50 — aucun
       colorway n'en demande et Liquid n'a pas émis le payload. */
    var galerie = lire(bloc.getAttribute('data-img-id')) || [];

    var laineObligatoire = bloc.getAttribute('data-laine-obligatoire') === '1';
    var peloteSecurite = bloc.getAttribute('data-pelote-securite') === '1';

    /* Coloris imposés.

       Le créateur fixe les couleurs : le client choisit sa taille, et
       son kit parmi les combinaisons proposées, mais ne dévie d'aucun
       coloris. Le colorway cesse d'être une suggestion pour devenir le
       kit lui-même.

       Ce qui change n'est pas tant l'affichage que les MODES D'ÉCHEC.
       Un colorway libre dont un coloris manque est masqué, sans
       gravité : le client compose à la main. Imposé, le masquer
       laisserait un bloc vide sans un mot. Aucun n'est donc masqué —
       ils sont proposés, et ce qui les bloque est dit : encart « kit
       incomplet » pour un coloris introuvable, alerte de stock
       chiffrée pour un coloris épuisé ou court. */
    var colorisImposes = bloc.getAttribute('data-coloris-imposes') === '1';

    /* Modèle épuisé — aucune de ses variantes n'est disponible.

       Le bloc reste affiché : la composition du kit renseigne le
       client qui attend le retour du modèle. Seul le pied change,
       puisqu'il n'y a rien à encaisser. Le bouton natif du thème,
       lui, garde la main : c'est sur lui que se greffent les apps
       d'alerte de retour en stock, et rien ici ne doit le neutraliser.

       `product.available` est vrai dès qu'UNE variante est
       disponible. Un modèle décliné dont une seule langue est épuisée
       garde donc son pied normal, et `variantesAChoisir()` écarte
       déjà la langue en question de son sélecteur. */
    var modeleIndispo = bloc.getAttribute('data-modele-indispo') === '1';

    /* Variante du modèle choisie DANS le bloc.
       Ne sert que sur une page kit, où le bloc « Buy buttons » du thème
       a été retiré : il n'y a alors plus de formulaire produit d'où
       lire la variante, et un modèle décliné — par langue, le plus
       souvent — n'aurait aucun moyen d'être choisi. Sur une fiche
       ordinaire, cette valeur reste nulle et le formulaire fait foi. */
    var varianteChoisie = null;
    var aDesVariantes = bloc.getAttribute('data-has-variants') === '1';

    /**
     * Variantes que le bloc doit faire choisir lui-même.
     *
     * Liste vide dans le cas courant : le modèle n'a qu'une variante,
     * ou le thème expose son formulaire et c'est lui qui commande.
     * Elle ne se remplit que sur une page kit dépouillée de son bloc
     * « Buy buttons », où sans cela un modèle décliné deviendrait
     * incommandable — `varianteModele()` renverrait `null`.
     *
     * « Le thème commande » veut dire : son formulaire porte une variante
     * de CE modèle. Un formulaire étranger sur la page — une carte de
     * recommandation — ne dispense plus le bloc de faire choisir.
     */
    function variantesAChoisir() {
      if (!aDesVariantes) return [];
      if (varianteDuFormulaire() !== null) return [];

      return Object.keys(modeleVariantes)
        .map(function (id) {
          var v = modeleVariantes[id];
          return { id: parseInt(id, 10), titre: v.titre, ordre: v.ordre || 0, dispo: v.dispo !== false };
        })
        .filter(function (v) { return v.dispo; })
        .sort(function (a, b) { return a.ordre - b.ordre; });
    }

    /* Le modèle est-il déjà au panier ?
       Renseigné à l'ouverture du bloc par un appel à /cart.js, puis
       après chaque ajout. `null` tant qu'on ne sait pas : le total
       inclut alors le modèle, hypothèse la plus prudente. */
    var modeleAuPanier = null;

    /**
     * Libellé affichable d'un composant.
     *
     * Trois cas :
     *   "Couleur principale"                  -> tel quel
     *   "sections.lat_kit.roles.principale"   -> traduction de la locale
     *   clé absente de la locale              -> dernier segment, remis
     *                                            en forme lisible
     *
     * Le dernier cas évite d'exposer une clé technique au client si
     * l'éditeur de langue de l'admin a effacé les entrées : mieux vaut
     * « Couleur principale » déduit du nom de clé qu'un chemin pointé.
     */
    function libelleRole(comp) {
      var r = String(comp.role || '').trim();
      if (!r) return comp.cle;
      if (r.indexOf('.') === -1 || r.indexOf(' ') !== -1) return r;

      var t = rolesTraduits[r];
      if (t && t.indexOf('translation missing') === -1) return deHtml(t);

      var seg = r.split('.').pop().replace(/_/g, ' ').trim();
      if (!seg) return r;
      return seg.charAt(0).toUpperCase() + seg.slice(1);
    }

    /**
     * Nom de fichier d'une image : sans chemin, sans paramètres, sans
     * extension, normalisé.
     *
     *   ".../files/1/0/hawthorn-kit-1.jpg?v=1726" -> "hawthorn-kit-1"
     */
    function nomFichier(src) {
      var f = String(src || '').split('?')[0].split('#')[0];
      f = f.substring(f.lastIndexOf('/') + 1);
      return norm(f.replace(/\.[a-z0-9]+$/i, ''));
    }

    /**
     * Photo d'un colorway, cherchée dans la galerie du modèle.
     *
     * Le metafield ne porte qu'un FRAGMENT DE NOM DE FICHIER, jamais
     * une URL : une URL s'y figerait — Shopify en change au moindre
     * renvoi du fichier — et priverait le bloc de la vignette que
     * `image_url` produit côté Liquid. Le marchand range donc la photo
     * dans la galerie du modèle, là où il range déjà les autres, et la
     * nomme.
     *
     * Exacte d'abord, sous-chaîne ensuite : Shopify suffixe les
     * collisions de nom (« kit-1_1.jpg »), ce qu'un fragment saisi à
     * l'avance ne peut pas prévoir.
     *
     * Un échec ne coûte que la vignette, et le bouton garde son
     * libellé : perdre le choix d'un kit parce qu'une photo a été
     * renommée serait une punition sans rapport avec la faute.
     */
    function imageColorway(cw) {
      var cible = nomFichier(cw && cw.image);
      if (!cible) return null;

      var exact = null, flous = [], i, f;
      for (i = 0; i < galerie.length; i++) {
        f = nomFichier(galerie[i].src);
        if (!f) continue;
        if (f === cible) { exact = galerie[i]; break; }
        if (f.indexOf(cible) !== -1) flous.push(galerie[i]);
      }

      var trouve = exact || flous[0] || null;
      if (!trouve) {
        signaler('img-' + cible, 'colorway "' + (cw.label || '') +
          '" : aucune image du modèle ne porte "' + cw.image +
          '" dans son nom de fichier');
        return null;
      }
      if (!exact && flous.length > 1) {
        signaler('imgamb-' + cible, 'colorway "' + (cw.label || '') + '" : ' +
          flous.length + ' images du modèle portent "' + cw.image +
          '" dans leur nom \u2014 la première est retenue');
      }
      return trouve.url || null;
    }

    var corps = bloc.querySelector('[data-lat-kit-body]');

    /* ---- État ---- */
    var etat = {
      optionIdx: 0,
      tailleIdx: -1,            // -1 = pas encore choisie
      choix: {},                // cle -> variante retenue
      colorway: null,           // label du colorway servant de point de départ
      colorwayDevie: false,     // le client a changé un coloris depuis
      colorwayIncomplet: false, // un coloris du colorway n'existe plus
      securite: {},             // cle -> true si le client veut +1 pelote
      /* Produits additionnels : index dans `kit.extras` -> variante
         retenue. Indexé par rang, et non par une clé, parce que le
         contrat n'en donne pas : un extra n'est référencé par rien
         d'autre, contrairement aux composants que les colorways
         désignent par leur `cle`. */
      extras: {},
      /* Formule retenue : 'kit' (modèle + laine) ou 'seul'.
         N'a de sens que si `laine_obligatoire` est faux — sinon le
         modèle ne se vend pas seul et l'onglet n'est pas offert. */
      mode: 'kit'
    };

    function optionCourante() { return kit.options[etat.optionIdx]; }

    /**
     * Composants que le modèle exige pour la taille choisie.
     *
     * Un composant dont le tableau `quantites` est incohérent avec
     * `tailles` est écarté : la donnée est inexploitable, mieux vaut
     * l'ignorer que de lire une quantité au hasard.
     */
    function composantsRequis() {
      var opt = optionCourante();
      if (!opt || !opt.composants || etat.tailleIdx < 0) return [];
      return opt.composants.filter(function (c) {
        if (!c.handle) return false;
        if (!c.quantites || c.quantites.length !== kit.tailles.length) {
          /* Par `signaler()` depuis la passe 53 : cette fonction est
             appelée une quinzaine de fois par rendu, et le même défaut
             s'écrivait soixante fois pour quatre gestes du client. */
          signaler('quantites-' + (c.cle || c.handle), libelleRole(c) +
            ' : ' + (c.quantites ? c.quantites.length : 0) +
            ' quantités pour ' + kit.tailles.length + ' tailles — composant ignoré');
          return false;
        }
        return c.quantites[etat.tailleIdx] > 0;
      });
    }

    /** Requis dont la laine est bien disponible. */
    function composantsActifs() {
      return composantsRequis().filter(function (c) { return !!laines[c.handle]; });
    }

    /**
     * Tailles réellement proposées par l'option courante.
     *
     * Une pièce d'un patron multi-pièces ne se décline pas toujours
     * dans toute la grille : la jupe Milly n'existe pas en XXS, où
     * tous ses composants portent 0. Laisser le bouton mènerait à un
     * écran vide sans un mot — `rendre()` s'arrête faute de composant
     * actif.
     *
     * Même règle que la taille unique, la qualité unique et les
     * colorways sans proposition : un choix qui n'offre rien est
     * masqué.
     *
     * `val` reste l'index dans `kit.tailles`, jamais celui de la liste
     * filtrée : c'est lui qui indexe les `quantites`.
     */
    function taillesOffertes() {
      var opt = optionCourante();
      var comps = (opt && opt.composants) || [];
      return kit.tailles.map(function (t, i) {
        return { label: t, val: i };
      }).filter(function (e) {
        return comps.some(function (c) {
          return c.quantites &&
            c.quantites.length === kit.tailles.length &&
            c.quantites[e.val] > 0;
        });
      });
    }

    /**
     * Coloris imposés introuvables, pour la taille choisie.
     *
     * Le pendant exact de `composantsIndisponibles()` : dans un cas la
     * laine manque, dans l'autre le coloris que le créateur a désigné
     * n'existe plus dans cette laine. Le client n'y peut rien ni dans
     * l'un ni dans l'autre, et le kit est incomplet des deux façons —
     * d'où le même encart et le même blocage.
     *
     * Vide hors du mode imposé : là, un coloris introuvable ne fait
     * que priver le client d'un pré-remplissage, et il choisit.
     */
    function colorisIntrouvables() {
      if (!colorisImposes) return [];
      return composantsActifs().filter(function (c) {
        return !etat.choix[c.cle];
      });
    }

    /**
     * Requis dont la laine est introuvable — produit dépublié,
     * supprimé, ou handle erroné dans le metafield.
     *
     * Ces composants ne peuvent PAS être simplement omis : le client
     * achèterait un kit auquel il manque une couleur, sans jamais
     * l'apprendre. Ils sont signalés et bloquent l'ajout au panier.
     */
    function composantsIndisponibles() {
      return composantsRequis().filter(function (c) {
        if (laines[c.handle]) return false;
        signaler('laine-' + (c.cle || '') + '-' + c.handle, 'laine introuvable pour ' +
          libelleRole(c) + ' : handle "' + c.handle +
          '" absent, dépublié, ou au-delà de la limite de 20 produits');
        return true;
      });
    }

    /** Quantité prévue par le créateur du modèle, pour la taille choisie. */
    function qteBase(comp) { return comp.quantites[etat.tailleIdx] || 0; }

    /**
     * Quantité réellement commandée : celle du modèle, plus la pelote
     * de sécurité si le client l'a demandée pour ce composant.
     *
     * C'est cette valeur qui sert partout — prix, stock, panier — sauf
     * pour décider si un composant est requis : une pelote de sécurité
     * ne doit pas rendre nécessaire une laine que le modèle n'utilise
     * pas dans cette taille.
     */
    function qteDe(comp) {
      return qteBase(comp) + (etat.securite[comp.cle] ? 1 : 0);
    }

    /* ==========================================================
       Stock

       Trois cas où la quantité disponible ne limite pas l'achat :
         - stock non suivi (`suivi` vide) : quantité illimitée
         - survente autorisée (`inventory_policy: continue`)
         - stock suffisant

       Le contrôle est une aide à la décision, PAS une garantie : les
       valeurs sont figées au rendu de la page et Shopify reste seul
       juge au moment de l'ajout. Une page laissée ouverte une heure
       peut afficher un stock périmé — /cart/add.js refusera alors la
       ligne et le message d'erreur de Shopify sera affiché.
       ========================================================== */

    /** Quantité réellement disponible, ou null si illimitée. */
    function stockDe(v) {
      if (!v.suivi) return null;
      if (v.survente) return null;
      return Math.max(0, v.stock || 0);
    }

    /** Le coloris couvre-t-il le besoin ? */
    function stockSuffisant(v, besoin) {
      var s = stockDe(v);
      return s === null || s >= besoin;
    }

    /** Coloris totalement épuisé (ni stock, ni survente). */
    function estEpuise(v) {
      var s = stockDe(v);
      return s !== null && s <= 0;
    }

    /**
     * Tailles où le coloris retenu couvrirait le besoin.
     *
     * Un coloris n'est jamais court dans l'absolu : il l'est pour LA
     * taille choisie. Nommer les tailles où il suffit transforme une
     * impasse en aiguillage — le client voit s'il peut s'en sortir en
     * changeant de taille plutôt que de coloris.
     *
     * On ÉNUMÈRE plutôt que d'écrire « jusqu'au M » : rien n'oblige
     * une grille à croître avec la taille. Les jupes de Milly portent
     * 0 en XXS, ce que la règle 9 autorise depuis toujours.
     *
     * Les tailles où le composant n'est pas requis sont écartées : y
     * annoncer un stock suffisant serait vrai et trompeur, puisque le
     * composant y est masqué.
     */
    function taillesSuffisantes(comp, v) {
      var stock = stockDe(v);
      if (stock === null) return [];      // illimité : aucun manque possible
      var bonus = etat.securite[comp.cle] ? 1 : 0;
      return taillesOffertes()
        .filter(function (t) {
          var base = (comp.quantites && comp.quantites[t.val]) || 0;
          return base > 0 && stock >= base + bonus;
        })
        .map(function (t) { return t.label; });
    }

    /**
     * Le manque ne tient-il qu'à la pelote de sécurité ?
     *
     * Cas fréquent, `pelote_securite` étant actif sur presque toutes
     * les fiches : le stock couvre exactement le besoin du patron, et
     * c'est la pelote en plus qui fait défaut. Le dire vaut mieux que
     * de renvoyer vers une autre taille — le client garde la sienne et
     * décoche une case.
     */
    function manqueDuALaSecurite(comp, v) {
      if (!etat.securite[comp.cle]) return false;
      return stockSuffisant(v, qteBase(comp));
    }

    /** Composants dont le coloris retenu ne couvre pas le besoin. */
    function manques() {
      var out = [];
      composantsActifs().forEach(function (c) {
        var v = etat.choix[c.cle];
        if (!v) return;
        var besoin = qteDe(c);
        if (!stockSuffisant(v, besoin)) {
          out.push({
            role: libelleRole(c),
            coloris: v.titre,
            dispo: stockDe(v) || 0,
            besoin: besoin,
            /* La sortie de secours, s'il y en a une. La pelote de
               sécurité passe devant : elle laisse au client la taille
               qu'il a choisie. */
            securite: manqueDuALaSecurite(c, v),
            tailles: taillesSuffisantes(c, v)
          });
        }
      });
      return out;
    }

    /**
     * Prix le plus bas et le plus haut parmi les coloris encore
     * CHOISISSABLES d'un composant. Un coloris épuisé ne peut pas
     * être retenu : il n'a pas à fixer le plancher.
     */
    function bornesPrix(comp) {
      var laine = laines[comp.handle];
      return bornesListe(laine ? laine.variantes.filter(function (v) {
        return !estEpuise(v);
      }) : []);
    }

    /**
     * Prix le plus bas et le plus haut d'une liste de variantes déjà
     * filtrée. Extrait de `bornesPrix()` à la passe 46 : les produits
     * additionnels ont besoin du même calcul, sur une liste qui ne se
     * déduit pas d'un composant.
     */
    function bornesListe(variantes) {
      var mini = null, maxi = null;
      variantes.forEach(function (v) {
        if (mini === null || v.prix < mini) mini = v.prix;
        if (maxi === null || v.prix > maxi) maxi = v.prix;
      });
      return { mini: mini === null ? 0 : mini, maxi: maxi === null ? 0 : maxi };
    }

    /* ==========================================================
       Produits additionnels — passe 46

       Un sac de projet, une paire d'aiguilles : ce que le kit
       contient en plus du modèle et de sa laine. Déclarés à la
       RACINE du metafield, parce qu'un sac appartient au kit et non
       à une qualité de laine, et parce qu'un modèle à trois options
       ne demande ainsi qu'une seule saisie.

       Le metafield ne porte qu'un HANDLE, comme pour la laine : le
       titre, le prix, l'image et le stock sont lus au rendu depuis
       le produit. Un sac qui change de prix se met à jour dans tous
       les kits sans intervention.

       UN EXTRA INDISPONIBLE NE BLOQUE PAS LA VENTE, contrairement à
       une laine introuvable. La laine EST le kit ; un sac ne l'est
       pas. Fermer un kit à 70 € parce qu'un tote bag offert manque
       serait disproportionné — la ligne passe « épuisé », sort du
       total, et n'est pas envoyée au panier.

       `offert` ne fait que compter zéro et l'afficher. C'est une
       REMISE AUTOMATIQUE Shopify qui rend l'article gratuit au
       panier : /cart/add.js ne peut pas imposer un prix, seul le
       moteur de remises le peut. Voir le garde-fou dans
       `verifierOfferts()`, et docs/02-deploiement.md § A5septies.
       ========================================================== */

    /* Avertissements de console, une fois chacun.

       `dessiner()` reconstruit tout à chaque clic, et les fonctions
       ci-dessous sont appelées plusieurs fois par rendu — total,
       plancher, récapitulatif, panier. Un handle erroné écrirait
       alors une dizaine de lignes identiques par clic, et la console
       cesserait d'être lisible au moment précis où l'on en a besoin.
       La clé retient ce qui a déjà été dit, pour ce bloc-ci. */
    var dejaDit = {};

    function signaler(cle, message) {
      if (dejaDit[cle]) return;
      dejaDit[cle] = true;
      if (window.console) console.warn('[lat-kit] ' + message);
    }

    /**
     * Extras exploitables — ceux qui portent un handle.
     *
     * C'est le RANG DANS CETTE LISTE, et non dans `kit.extras`, qui
     * sert de clé à `etat.extras` : le contrat ne donne aux extras
     * aucun identifiant, contrairement aux composants que les
     * colorways désignent par leur `cle`. Toute lecture passe donc
     * par cette fonction, jamais par `kit.extras` directement.
     */
    function extrasDeclares() {
      /* Le test de type n'est pas décoratif : `extras` se saisit à la
         main dans un champ JSON, et une chaîne a une `length` — sans
         lui, `"extras": "sac"` jetterait sur `.filter` et emporterait
         le bloc entier. */
      if (!kit.extras || !Array.isArray(kit.extras)) return [];
      return kit.extras.filter(function (ex) {
        return ex && typeof ex.handle === 'string' && ex.handle;
      });
    }

    /** Quantité commandée : un entier positif, 1 par défaut. */
    function qteExtra(ex) {
      var q = parseInt(ex.quantite, 10);
      return (isFinite(q) && q > 0) ? q : 1;
    }

    /**
     * Une variante d'extra est-elle livrable ?
     *
     * Le stock court vaut ici épuisement, là où il est seulement
     * signalé pour la laine. La différence tient à la sortie : un
     * coloris court redevient suffisant dans une autre taille, et le
     * client peut y aller. La quantité d'un extra, elle, est fixe —
     * il n'existe aucun geste qui la ferait tenir dans le stock.
     */
    function achetableExtra(ex, v) {
      return !estEpuise(v) && stockSuffisant(v, qteExtra(ex));
    }

    /**
     * Variantes achetables d'un extra.
     *
     * Une `variante` imposée par le metafield réduit la liste à elle
     * seule — c'est ainsi qu'on désigne « Aiguilles 4 mm » dans un
     * produit qui en compte douze. Elle est résolue par la cascade
     * des colorways : titre, titre approchant, ou identifiant.
     *
     * Une valeur imposée introuvable ne fait pas disparaître l'extra :
     * elle est signalée en console et le choix revient au client.
     * Perdre le sac parce qu'une variante a été renommée serait une
     * punition sans rapport avec la faute.
     */
    function variantesExtra(ex) {
      var prod = laines[ex.handle];
      if (!prod) return [];

      var achetables = prod.variantes.filter(function (v) {
        return achetableExtra(ex, v);
      });

      var impose = String(ex.variante == null ? '' : ex.variante).trim();
      if (!impose) return achetables;

      var vImposee = trouverVariante(prod.variantes, impose);
      if (!vImposee) {
        signaler('variante-' + ex.handle + '-' + impose,
          'produit additionnel ' + ex.handle + ' : variante "' + impose +
          '" introuvable — le choix revient au client');
        return achetables;
      }
      return achetableExtra(ex, vImposee) ? [vImposee] : [];
    }

    /**
     * Variante retenue pour un extra, ou `null` s'il reste à choisir.
     *
     * Une seule variante achetable : elle est retenue d'office, sans
     * demander un clic qui n'offre aucun choix — même règle que la
     * taille unique et la qualité unique.
     *
     * La sélection du client est relue dans la liste courante plutôt
     * que rendue telle quelle : la variante qu'il avait retenue a pu
     * s'épuiser entre-temps.
     */
    function varianteExtra(ex, idx) {
      var vs = variantesExtra(ex);
      if (!vs.length) return null;
      if (vs.length === 1) return vs[0];

      var retenue = etat.extras[idx];
      if (!retenue) return null;
      for (var i = 0; i < vs.length; i++) {
        if (vs[i].id === retenue.id) return vs[i];
      }
      return null;
    }

    /** Produit absent du préchargement, ou plus rien d'achetable. */
    function extraIndisponible(ex) {
      if (!laines[ex.handle]) {
        signaler('absent-' + ex.handle,
          'produit additionnel introuvable : handle "' + ex.handle +
          '" absent, dépublié, ou au-delà de la limite de 20 produits');
        return true;
      }
      return variantesExtra(ex).length === 0;
    }

    /** Extras vendables, chacun avec son rang dans `extrasDeclares()`. */
    function extrasActifs() {
      var out = [];
      extrasDeclares().forEach(function (ex, i) {
        if (!extraIndisponible(ex)) out.push({ ex: ex, idx: i });
      });
      return out;
    }

    /**
     * Extras dont on a de quoi parler au client : le produit est
     * préchargé, donc son titre et ses variantes sont connus.
     *
     * Distinct d'`extrasActifs()` : un sac épuisé reste AFFICHÉ — la
     * ligne dit « épuisé » — mais n'est ni compté ni ajouté. Un sac
     * dont le produit manque, lui, n'a pas même un titre à montrer :
     * il disparaît, et seule la console le signale.
     */
    function extrasAffichables() {
      var out = [];
      extrasDeclares().forEach(function (ex, i) {
        if (laines[ex.handle]) out.push({ ex: ex, idx: i });
      });
      return out;
    }

    /** Extras qui attendent encore un choix du client. */
    function extrasAChoisir() {
      return extrasActifs().filter(function (e) {
        return varianteExtra(e.ex, e.idx) === null;
      });
    }

    /**
     * Prix d'un extra pour la quantité prévue, en centimes.
     *
     * Offert : zéro. Sinon, le prix de la variante retenue — ou, tant
     * qu'il n'y en a pas, celui de la moins chère. Compter zéro
     * jusqu'au choix ferait clignoter le total, ce que la passe 40 a
     * corrigé pour la laine.
     */
    function prixExtra(ex, idx) {
      if (ex.offert === true) return 0;
      var v = varianteExtra(ex, idx);
      var unite = v ? v.prix : bornesListe(variantesExtra(ex)).mini;
      return unite * qteExtra(ex);
    }

    /** Total des produits additionnels, en centimes. */
    function totalExtras() {
      var t = 0;
      extrasActifs().forEach(function (e) { t += prixExtra(e.ex, e.idx); });
      return t;
    }

    /**
     * Part des extras dans le prix plancher du kit.
     *
     * Toujours la variante la moins chère, sans lire `etat` : le
     * plancher répond à « combien, au minimum » et ne porte pas la
     * sélection en cours. Voir `plancherOption()`, qui suit la même
     * règle pour la laine.
     */
    function plancherExtras() {
      var t = 0;
      extrasActifs().forEach(function (e) {
        if (e.ex.offert === true) return;
        t += bornesListe(variantesExtra(e.ex)).mini * qteExtra(e.ex);
      });
      return t;
    }

    /**
     * Total de la laine, en centimes.
     *
     * Un composant non encore choisi compte au prix de son coloris le
     * moins cher, et non pour zéro. Jusqu'à la passe 40, le pied
     * annonçait la moitié d'un kit à deux fils tant que le second
     * n'était pas retenu : un chiffre plausible, affiché en 20 px, et
     * faux — de la même famille que le prix du livret seul en tête de
     * fiche.
     *
     * Quand tous les coloris d'une laine partagent leur prix — le cas
     * normal — ce total est EXACT dès l'ouverture et ne bouge plus
     * pendant que le client compose. Sinon c'est un plancher, et
     * `totalEstime()` le fait dire plutôt que de le taire.
     */
    function totalLaine() {
      var t = 0;
      composantsActifs().forEach(function (c) {
        var v = etat.choix[c.cle];
        t += (v ? v.prix : bornesPrix(c).mini) * qteDe(c);
      });
      return t;
    }

    /** Le total affiché est-il un plancher plutôt qu'un montant ? */
    function totalEstime() {
      var laineFloue = composantsActifs().some(function (c) {
        if (etat.choix[c.cle]) return false;
        var b = bornesPrix(c);
        return b.maxi > b.mini;
      });
      if (laineFloue) return true;

      /* Un extra à choisir dont les variantes n'ont pas toutes le même
         prix — un sac décliné en deux tailles, par exemple. Un extra
         offert ne compte pas : son zéro est certain. */
      return extrasActifs().some(function (e) {
        if (e.ex.offert === true) return false;
        if (varianteExtra(e.ex, e.idx)) return false;
        var b = bornesListe(variantesExtra(e.ex));
        return b.maxi > b.mini;
      });
    }

    /**
     * Intitulé du total.
     *
     * Il suit ce que le montant CONTIENT, et non ce que la fiche
     * propose : « Total laine » seulement quand la somme est celle de
     * la laine seule, « Total » dès qu'autre chose s'y ajoute.
     *
     * Il se lisait jusqu'à la passe 47 sur `prixModele() > 0`, ce qui
     * se trompait des deux côtés :
     *
     *   - modèle DÉJÀ AU PANIER : son prix reste non nul, mais
     *     `modeleCompte()` le retire du total. Le montant était celui
     *     de la laine seule, et s'annonçait « Total » ;
     *   - modèle À 0 € avec un produit additionnel payant : le
     *     montant comprend le sac, et s'annonçait « Total laine ».
     *
     * Le second est né avec la passe 46. Le premier existait depuis
     * toujours, et `tests/test-total-et-focus.js` décrivait pourtant
     * déjà le bon comportement — « modèle déjà au panier : Total
     * laine ». Personne n'a vu que le bloc ne le suivait pas, parce
     * que le noyau recopié dans le test prend un BOOLÉEN là où le bloc
     * lisait un PRIX. Le miroir était juste, l'original non.
     *
     * Le « à partir de » reste porté par l'intitulé : en 16 px et en
     * graisse normale, il le dit sans crier — le montant, lui, reste
     * en 20 px et n'a pas à s'encombrer.
     */
    function libelleTotal() {
      var base = (totalKit() === totalLaine()) ? S.total : S.total_kit;
      return totalEstime() ? (base + ' ' + S.a_partir_de) : base;
    }

    /** Prix du modèle dans la variante actuellement sélectionnée. */
    function prixModele() {
      var id = varianteModele();
      var m = id ? modeleVariantes[String(id)] : null;
      return m ? m.prix : 0;
    }

    /**
     * Le modèle compte-t-il dans le total annoncé ?
     * Non s'il est déjà au panier : le client ne le paiera pas deux fois.
     */
    function modeleCompte() {
      return prixModele() > 0 && modeleAuPanier !== true;
    }

    /** Total effectivement ajouté au panier. */
    function totalKit() {
      return totalLaine() + totalExtras() +
        (modeleCompte() ? prixModele() : 0);
    }

    /**
     * Plancher d'une qualité dans une taille donnée, laine seule, en
     * centimes — ou `null` si la combinaison n'est pas composable.
     *
     * Parcourt la grille sans toucher à `etat` : les quantités sont
     * relues dans `quantites[idxTaille]` et non par `qteDe()`, qui lit
     * la taille retenue et y ajoute la pelote de sécurité. Un plancher
     * ne porte pas d'option payante que le client n'a pas demandée.
     */
    function plancherOption(opt, idxTaille) {
      if (colorisImposes) return plancherImpose(opt, idxTaille);

      var comps = (opt && opt.composants) || [];
      var total = 0;
      var requis = false;

      for (var j = 0; j < comps.length; j++) {
        var c = comps[j];
        if (!c.quantites || c.quantites.length !== kit.tailles.length) continue;

        var q = c.quantites[idxTaille] || 0;
        if (q <= 0) continue;   // composant non requis dans cette taille

        var laine = laines[c.handle];
        if (!laine) return null;   // laine introuvable : rien à chiffrer

        /* Aucun coloris achetable : bornesPrix() rendrait 0 et le
           plancher annoncerait un kit moins cher qu'il ne peut
           l'être. Cette qualité ne compte pas. */
        var achetable = laine.variantes.some(function (v) {
          return !estEpuise(v);
        });
        if (!achetable) return null;

        requis = true;
        total += bornesPrix(c).mini * q;
      }

      /* Aucun composant requis : la taille n'existe pas dans cette
         qualité — même situation que taillesOffertes(). Retenir 0
         donnerait un plancher gratuit. */
      return requis ? total : null;
    }

    /**
     * Plancher d'une qualité à coloris imposés : le moins cher des
     * KITS proposés, et non le moins cher des coloris.
     *
     * La nuance n'est pas théorique. `bornesPrix()` balaie tous les
     * coloris encore achetables de la laine ; imposés, ils ne sont pas
     * achetables — un seul l'est par composant, celui du colorway. Le
     * plancher ordinaire annoncerait donc un kit moins cher que le
     * moins cher des kits, et le pied le contredirait au premier choix
     * de taille. C'est le piège déjà payé une fois avec les produits
     * additionnels, au même endroit.
     *
     * Un colorway dont un coloris est introuvable ou épuisé ne compte
     * pas : on ne peut pas l'acheter, il n'a pas à fixer le plancher.
     */
    function plancherImpose(opt, idxTaille) {
      var cws = (opt && opt.colorways) || [];
      var comps = (opt && opt.composants) || [];
      var mini = null;

      cws.forEach(function (cw) {
        var total = 0, requis = false, ok = true;

        comps.forEach(function (c) {
          if (!ok) return;
          if (!c.quantites || c.quantites.length !== kit.tailles.length) return;

          var q = c.quantites[idxTaille] || 0;
          if (q <= 0) return;                 // non requis dans cette taille

          var laine = laines[c.handle];
          if (!laine) { ok = false; return; }

          var v = trouverVariante(laine.variantes,
            cw.choix ? cw.choix[c.cle] : null);
          if (!v || estEpuise(v)) { ok = false; return; }

          requis = true;
          total += v.prix * q;
        });

        if (ok && requis && (mini === null || total < mini)) mini = total;
      });

      return mini;
    }

    /**
     * Prix du kit complet le moins cher, modèle compris, en centimes.
     * `null` si aucune combinaison n'est composable.
     *
     * Ce n'est pas le total du pied : celui-ci chiffre la sélection en
     * cours, celui-là balaie toute la grille taille × qualité pour
     * répondre à la seule question que se pose un client qui vient
     * d'arriver — combien, au minimum.
     */
    function plancherKit() {
      var mini = null;
      for (var o = 0; o < kit.options.length; o++) {
        for (var i = 0; i < kit.tailles.length; i++) {
          var t = plancherOption(kit.options[o], i);
          if (t === null) continue;
          if (mini === null || t < mini) mini = t;
        }
      }
      /* Les extras entrent dans le plancher : sans eux, l'ancre
         annoncerait un kit moins cher que le moins cher des kits, et
         le pied la contredirait au premier choix de taille. */
      return mini === null ? null : mini + prixModele() + plancherExtras();
    }

    /**
     * Le prix du kit, en tête du bloc.
     *
     * Sur une fiche à laine obligatoire, le seul prix que la page
     * affiche est celui que le thème tire de `product.price` : celui
     * du livret seul, 3,50 €, qu'aucun client ne peut payer puisque le
     * modèle ne se vend pas sans sa laine. Le bloc, lui, ne chiffrait
     * rien tant qu'une taille n'était pas retenue. Le client voyait
     * donc un prix, un seul, et c'était le mauvais.
     *
     * L'ancre comble exactement cet intervalle : elle paraît quand le
     * pied est encore absent, et disparaît dès qu'il prend le relais.
     * Deux montants à l'écran se contrediraient tôt ou tard.
     */
    function ancrePrix(montant) {
      var a = el('div', 'lat-kit__ancre');

      var ligne = el('div', 'lat-kit__ancre-ligne');
      ligne.appendChild(el('span', null, S.prix_kit + ' ' + S.a_partir_de));
      ligne.appendChild(el('b', null, prix(montant)));
      a.appendChild(ligne);

      a.appendChild(el('div', 'lat-kit__ancre-taxes',
        taxesIncluses ? S.taxes_ttc : S.taxes_ht));

      return a;
    }

    /** Interroge le panier et rafraîchit l'affichage si l'état change.
        Un bloc sorti de la page ne lit plus rien — voir `horsPage()`. */
    function rafraichirEtatPanier() {
      if (horsPage()) return;
      var id = varianteModele();
      if (!id) return;
      fetch(racine() + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (panier) {
          var present = (panier.items || []).some(function (it) {
            return it.variant_id === id;
          });
          if (present !== modeleAuPanier) {
            modeleAuPanier = present;
            rendre();
          }
        })
        .catch(function () { /* total incluant le modèle : hypothèse prudente */ });
    }

    function toutChoisi() {
      var actifs = composantsActifs();
      if (!actifs.length) return false;
      /* Un sac décliné en coloris compte comme un choix à faire : le
         bouton reste bloqué tant qu'il n'est pas retenu, faute de quoi
         le panier recevrait une variante tirée au sort. */
      if (extrasAChoisir().length) return false;
      return actifs.every(function (c) { return !!etat.choix[c.cle]; });
    }

    /* ---- Rendu ---- */

    /* ==========================================================
       Rendu — enveloppe

       `dessiner()` reconstruit le corps de bout en bout, ce qui fait
       disparaître le bouton que le client vient d'activer. Sans rien
       de plus, le focus retombe alors sur `<body>` : au clavier, on
       est renvoyé en tête de page à CHAQUE choix, et il faut
       re-tabuler l'en-tête, la galerie et la description pour
       atteindre le choix suivant. Un kit à deux fils demande six
       choix — le bloc devient impraticable sans souris.

       D'où l'enveloppe : on note quel élément avait le focus, on
       redessine, on le rend à son remplaçant. Chaque contrôle porte
       pour cela un `data-cle` stable, qui survit au re-rendu.

       L'annonce ferme la marche : sans elle, un lecteur d'écran ne
       dit rien du total qui change ni de l'alerte qui apparaît.
       ========================================================== */
    function rendre() {
      var focusCle = null;
      var actif = document.activeElement;
      if (actif && corps.contains(actif)) {
        focusCle = actif.getAttribute('data-cle');
      }

      dessiner();

      if (focusCle) {
        /* Parcours plutôt que sélecteur construit : la `cle` d'un
           composant vient du metafield, et un guillemet y casserait
           un `querySelector`. */
        var candidats = corps.querySelectorAll('[data-cle]');
        for (var i = 0; i < candidats.length; i++) {
          if (candidats[i].getAttribute('data-cle') !== focusCle) continue;
          try { candidats[i].focus({ preventScroll: true }); }
          catch (err) { candidats[i].focus(); }
          break;
        }
      }

      annoncer();
    }

    /**
     * Écrit dans la région d'annonce, si le texte a changé.
     *
     * Court volontairement : un lecteur d'écran relit tout le contenu
     * à chaque modification, et une phrase longue couvrirait le geste
     * suivant du client. On dit ce qui a bougé, pas ce qui est.
     */
    function annoncer() {
      var zone = bloc.querySelector('[data-lat-kit-annonce]');
      if (!zone) return;

      var texte;
      if (modeleIndispo) {
        texte = S.rupture_titre;
      } else if (etat.mode === 'seul' && !laineObligatoire) {
        /* La formule « modèle seul » sort avant le choix de la taille :
           sans cette branche, elle n'annoncerait jamais rien. */
        texte = S.total_modele + ' ' + prix(prixModele());
      } else if (etat.tailleIdx < 0) {
        /* Le pied n'existe pas encore : c'est l'ancre qui porte le
           prix, donc c'est elle qu'on annonce. Sa valeur bouge avec la
           langue du livret, les variantes d'un modèle n'ayant pas
           toutes le même prix. */
        var plancher = plancherKit();
        texte = plancher === null
          ? ''
          : (S.prix_kit + ' ' + S.a_partir_de + ' ' + prix(plancher));
      } else if (manques().length) {
        texte = S.stock_titre;
      } else {
        texte = libelleTotal() + ' ' + prix(totalKit());
      }

      if (zone.textContent !== texte) zone.textContent = texte;
    }

    function dessiner() {
      corps.innerHTML = '';

      /* Format de livraison — une information, pas un choix.
         Le metafield ne retient qu'un code ; le libellé vient de la
         locale, sinon il s'afficherait dans la langue de saisie sur
         tous les marchés, le metafield étant partagé entre eux.

         La table est écrite en clair, et non résolue par un accès
         dynamique du genre S[prefixe + code] : verifie-syntaxe.js
         repère l'usage d'une entrée à sa notation pointée, et
         prendrait les trois libellés pour des clés mortes. */
      var FORMATS = {
        pdf:        S.format_pdf,
        papier:     S.format_papier,
        pdf_papier: S.format_pdf_papier
      };
      /* ==========================================================
         Format et langue du modèle

         Deux informations sur le même objet — le livret — réunies
         sous un seul intitulé depuis la passe 37. Le format y perd
         son préfixe « Format : » : l'intitulé le porte déjà, et le
         répéter coûtait une ligne pour rien.

         L'INTITULÉ SUIT CE QUI EST RÉELLEMENT AFFICHÉ. Une zone
         titrée « Format et langue du modèle » qui n'offrirait aucune
         langue promettrait un choix inexistant — et c'est le cas
         courant, la plupart des modèles n'ayant qu'une variante.

         Rendue avant tout le reste : les deux formules ont besoin de
         savoir QUELLE variante part au panier, et c'est ici que
         `varianteChoisie` se renseigne. Le sélecteur lui-même ne
         paraît que si le thème n'offre plus de formulaire pour la
         choisir — voir variantesAChoisir().
         ========================================================== */
      var libFormat = FORMATS[String(kit.format || '')];
      var versions = variantesAChoisir();
      var choixLangue = versions.length > 1;

      /* « Ne se vend pas seul » — passe 42.

         Redessinée à chaque passage, alors qu'elle était posée une
         fois pour toutes avant le corps : `dessiner()` vide le corps,
         et c'est maintenant dedans qu'elle vit. */
      var noteFormule = laineObligatoire
        ? el('div', 'lat-kit__obligatoire', S.obligatoire)
        : null;

      if (versions.length && varianteChoisie === null) {
        varianteChoisie = versions[0].id;
      }

      /* Langue MONTRÉE sans être choisie.
         Passe 39.

         Un choix qui n'offre rien est masqué — c'est la règle du bloc
         depuis la passe 25, appliquée à la taille unique, à la qualité
         unique et aux colorways sans proposition. Mais masquer le
         BOUTON ne doit pas faire taire l'INFORMATION : un livret part
         dans une langue, et le client a le droit de savoir laquelle.

         Trois situations mènent ici : le modèle n'a qu'une version, il
         en a plusieurs mais une seule est disponible, ou le thème a
         gardé son formulaire et commande le choix lui-même.

         `aDesVariantes` écarte le seul cas où l'afficher n'aurait pas
         de sens : le `Default Title` que Shopify donne à la variante
         unique d'un produit sans options. */
      var libLangue = null;
      if (!choixLangue && aDesVariantes) {
        var idCourant = varianteModele();
        var vCourante = idCourant ? modeleVariantes[String(idCourant)] : null;
        if (vCourante && vCourante.titre) libLangue = vCourante.titre;
      }

      if (libFormat || choixLangue || libLangue) {
        var secModele = el('div', 'lat-kit__section');
        secModele.appendChild(el('div', 'lat-kit__label',
          (choixLangue || libLangue)
            ? (libFormat ? S.format_variante : S.variante)
            : S.format));

        /* Une seule ligne quand les deux sont connus : « Livret papier
           — Anglais ». Deux informations sur le même objet, pas deux
           lignes à lire. */
        if (libFormat || libLangue) {
          secModele.appendChild(el('div', 'lat-kit__format',
            (libFormat && libLangue)
              ? (libFormat + ' \u2014 ' + libLangue)
              : (libFormat || libLangue)));
        }

        if (choixLangue) {
          secModele.appendChild(groupeChoix(
            versions.map(function (v) {
              return { label: v.titre, actif: v.id === varianteChoisie,
                       val: v.id, cle: 'version-' + v.id };
            }),
            function (id) {
              varianteChoisie = id;
              modeleAuPanier = null;   // l'état portait sur l'autre version
              refleterVarianteDansUrl(id);
              rendre();
              rafraichirEtatPanier();
            },
            S.variante
          ));
        }

        /* En PIED de zone, sous le format et la langue, et non entre
           les deux : quand la langue se choisit, ses boutons
           appartiennent à l'intitulé qui les annonce, et la note s'y
           glisserait au milieu. */
        if (noteFormule) {
          secModele.appendChild(noteFormule);
          noteFormule = null;
        }

        corps.appendChild(secModele);
      }

      /* Aucune zone modèle où la ranger — un modèle sans format
         déclaré, à variante unique et sans titre à montrer. La note
         reprend alors sa zone à elle, en tête du corps. */
      if (noteFormule) {
        var secNote = el('div', 'lat-kit__section');
        secNote.appendChild(noteFormule);
        corps.appendChild(secNote);
      }

      /* ==========================================================
         Formule — le modèle seul, ou le modèle avec sa laine.

         N'apparaît que si le modèle PEUT se vendre seul, c'est-à-dire
         quand `laine_obligatoire` est faux. Rien de nouveau au
         contrat de données : c'est le drapeau qui existait déjà, lu
         dans l'autre sens.

         Ni quand le modèle est épuisé : il n'y a alors rien à
         acheter d'aucune façon, et offrir un choix entre deux
         impossibilités n'aide personne. Le pied de rupture parle pour
         les deux formules.

         Le défaut est le kit : c'est la formule que la boutique met
         en avant, et celle qui existait avant cette passe. Une
         boutique qui vend surtout des PDF — Icelandic Knitter —
         renversera l'ordre le jour où le besoin sera avéré.
         ========================================================== */
      if (!laineObligatoire && !modeleIndispo) {
        corps.appendChild(blocChoix(
          S.mode,
          [{ label: S.mode_seul, actif: etat.mode === 'seul', val: 'seul',
             cle: 'mode-seul' },
           { label: S.mode_kit,  actif: etat.mode === 'kit',  val: 'kit',
             cle: 'mode-kit' }],
          function (m) {
            etat.mode = m;
            rendre();
          }
        ));
      }

      /* Modèle seul : la laine n'a plus rien à dire ici. Ni taille,
         ni qualité, ni coloris — ces sections ne servent qu'à
         composer un kit. Le pied se réduit au prix du modèle et à son
         bouton. */
      if (etat.mode === 'seul' && !laineObligatoire && !modeleIndispo) {
        corps.appendChild(rendrePiedSeul());
        return;
      }

      /* Taille — masquée s'il n'y en a qu'une, et retenue d'office :
         un bouton seul n'offre aucun choix, il ne fait qu'exiger un
         clic de plus avant de voir les laines. Même règle que la
         qualité unique et que les colorways sans proposition.
         Rien ne se perd : la taille reste au récapitulatif et sur la
         ligne de panier. */
      if (kit.tailles.length === 1) {
        etat.tailleIdx = 0;
      } else {
        var offertes = taillesOffertes();

        /* La taille retenue peut ne pas exister dans l'option qu'on
           vient de choisir — passer du pull Milly en XXS à la jupe,
           qui commence au XS. On la relâche plutôt que de composer un
           kit vide. */
        var tenue = offertes.some(function (o) { return o.val === etat.tailleIdx; });
        if (etat.tailleIdx >= 0 && !tenue) etat.tailleIdx = -1;

        if (offertes.length === 1) {
          etat.tailleIdx = offertes[0].val;
        } else {
          corps.appendChild(blocChoix(
            S.taille,
            offertes.map(function (o) {
              return { label: o.label, actif: o.val === etat.tailleIdx,
                       val: o.val, cle: 'taille-' + o.val };
            }),
            function (i) {
              etat.tailleIdx = i;
              rendre();
            }
          ));
        }
      }

      // Qualité, seulement si plusieurs
      if (kit.options.length > 1) {
        corps.appendChild(blocChoix(
          S.qualite,
          kit.options.map(function (o, i) {
            return { label: o.label, actif: i === etat.optionIdx,
                     val: i, cle: 'qualite-' + i };
          }),
          function (i) {
            etat.optionIdx = i;
            etat.choix = {};
            etat.colorway = null;
            etat.colorwayDevie = false;
            etat.colorwayIncomplet = false;
            etat.securite = {};
            rendre();
          }
        ));
      }

      // Rien de plus tant que la taille n'est pas choisie
      if (etat.tailleIdx < 0) {
        /* Sauf le prix. Posé en TÊTE du corps — donc au-dessus du
           format et de la formule déjà écrits — parce qu'il répond à
           la première question du client, et parce que c'est là que
           son regard arrive après le prix du thème.

           Rien quand le modèle est épuisé : le pied de rupture retire
           déjà le total du kit pour ne pas annoncer un montant qu'on
           ne peut pas encaisser, et une ancre le remettrait en haut. */
        if (!modeleIndispo) {
          var plancher = plancherKit();
          if (plancher !== null) {
            corps.insertBefore(ancrePrix(plancher), corps.firstChild);
          }
        }

        var invite = el('div', 'lat-kit__section');
        invite.appendChild(el('div', 'lat-kit__comp-yarn', S.taille_choix));
        corps.appendChild(invite);
        return;
      }

      var opt = optionCourante();
      var actifs = composantsActifs();
      var cws = (opt && opt.colorways) || [];
      var rangCw = -1;

      /* Coloris imposés : le colorway est calé AVANT l'encart des
         laines manquantes, parce qu'un coloris introuvable y figure au
         même titre qu'une laine absente. */
      if (colorisImposes && actifs.length) {
        if (cws.length) {
          rangCw = calerColorway(cws, actifs);
        } else {
          signaler('cw-absent-' + etat.optionIdx,
            'coloris imposés : la qualité "' + (opt.label || etat.optionIdx) +
            '" ne propose aucun colorway \u2014 rien n\u2019est achetable');
        }
      }

      var absents = composantsIndisponibles().concat(colorisIntrouvables());

      /* Une laine requise est introuvable : le kit ne peut pas être
         vendu tel quel. On l'annonce avant tout le reste plutôt que
         de laisser le client composer une sélection inachetable. */
      if (absents.length) {
        /* Nommé `encart`, et non `bloc` : `var` porte sur toute la
           fonction, si bien qu'un `var bloc` ici masquerait l'élément
           racine du bloc dans l'ensemble de `rendre()`, y compris
           au-dessus de cette ligne. */
        var encart = el('div', 'lat-kit__alerte');
        encart.appendChild(el('div', 'lat-kit__alerte-titre', S.indispo_titre));
        var lst = el('ul', 'lat-kit__alerte-liste');
        absents.forEach(function (c) {
          lst.appendChild(el('li', null, libelleRole(c)));
        });
        encart.appendChild(lst);
        encart.appendChild(el('div', 'lat-kit__alerte-aide', S.indispo_aide));
        corps.appendChild(encart);
      }

      if (!actifs.length) return;

      // Colorways
      if (colorisImposes) {
        /* Aucun n'est masqué, et l'intitulé change : « suggérés »
           serait faux là où l'on ne peut pas en sortir. Un kit unique
           n'affiche aucun bouton — un choix qui n'offre rien est masqué
           depuis la passe 25 — mais il reste calé, et la liste des
           couleurs le montre. */
        if (cws.length > 1) {
          corps.appendChild(blocChoix(S.colorways_imposes,
            cws.map(function (cw, i) {
              return { label: cw.label, actif: i === rangCw, val: i,
                       cle: 'colorway-' + i, img: imageColorway(cw) };
            }),
            function (i) { appliquerColorway(cws[i], actifs); }
          ));
        }
      } else if (cws.length) {
        var proposables = [];
        cws.forEach(function (cw, i) {
          if (colorwayUtilisable(cw, actifs)) {
            /* Dès que le client dévie d'un coloris, le bouton se
               relâche : laisser « Marine (photo) » enfoncé alors que
               la sélection n'est plus celle de la photo ferait croire
               à une combinaison qui n'est plus proposée. La propriété
               de panier, elle, garde la trace du point de départ avec
               le suffixe « — modifié » : c'est ce qui dit au SAV si la
               suggestion du créateur a été suivie. */
            proposables.push({
              label: cw.label,
              actif: etat.colorway === cw.label && !etat.colorwayDevie,
              val: i,
              cle: 'colorway-' + i,
              img: imageColorway(cw)
            });
          }
        });

        /* Aucun colorway commandable : la section entière disparaît
           plutôt que d'afficher un titre suivi de rien. */
        if (proposables.length) {
          corps.appendChild(blocChoix(S.colorways, proposables, function (i) {
            appliquerColorway(cws[i], actifs);
          }));
        }
      }

      // Composants
      var sec = el('div', 'lat-kit__section');
      if (colorisImposes) {
        /* Une seule laine pour toutes les couleurs — le cas du
           jacquard — et elle se nomme une fois, en tête, comme le
           patron le fait. La répéter dix fois n'apprendrait rien et
           noierait les coloris, qui sont l'information de la liste. */
        var handles = [];
        actifs.forEach(function (c) {
          if (handles.indexOf(c.handle) === -1) handles.push(c.handle);
        });
        var uneLaine = handles.length === 1 ? laines[handles[0]] : null;
        if (uneLaine) sec.appendChild(ligneLaine(uneLaine, 'lat-kit__fixe-laine'));
        actifs.forEach(function (comp) {
          sec.appendChild(rendreComposantFixe(comp, !uneLaine));
        });
      } else {
        actifs.forEach(function (comp) { sec.appendChild(rendreComposant(comp)); });
      }
      corps.appendChild(sec);

      /* Produits additionnels — passe 46.

         APRÈS la laine : c'est l'ordre de lecture du kit, du principal
         à l'accessoire, et celui que reprend le récapitulatif.

         La zone suit la même règle que le reste du corps — rien avant
         que la taille ne soit choisie. Un sac ne dépend pourtant
         d'aucune taille, mais l'afficher plus tôt ferait paraître une
         zone au milieu d'un corps encore vide, sous une invite qui
         demande justement de choisir une taille. */
      var extras = extrasAffichables();
      if (extras.length) {
        var secEx = el('div', 'lat-kit__section');
        secEx.appendChild(el('div', 'lat-kit__label', S.inclus));
        extras.forEach(function (e) {
          secEx.appendChild(rendreExtra(e.ex, e.idx));
        });
        corps.appendChild(secEx);
      }

      corps.appendChild(modeleIndispo ? rendrePiedRupture() : rendrePied());
    }

    /**
     * Un colorway est-il applicable en l'état ?
     *
     * Non si l'un de ses coloris est introuvable, épuisé, ou en
     * quantité insuffisante pour la taille choisie.
     *
     * Les colorways inapplicables sont MASQUÉS, non annotés. Un
     * raccourci qui mène à un bouton bloqué n'est pas une suggestion,
     * c'est une impasse : le client clique, sa sélection se remplit, et
     * il découvre qu'il ne peut pas commander. Mieux vaut ne proposer
     * que ce qui est réellement commandable.
     *
     * La disponibilité dépendant de la taille, un colorway masqué en
     * 5XL peut réapparaître en M. C'est voulu.
     */
    function colorwayUtilisable(cw, actifs) {
      var res = resoudreColorway(cw, actifs);

      if (res.manquants.length) {
        /* Coloris introuvable : anomalie de données, pas de stock.
           Signalé en console pour que le catalogue soit corrigé — une
           fois, et non à chaque rendu. */
        res.manquants.forEach(function (comp) {
          signaler('cw-masque-' + cw.label + '-' + comp.cle,
            'colorway "' + cw.label + '" masqué : coloris "' +
            (cw.choix ? cw.choix[comp.cle] : '(non renseigné)') +
            '" introuvable dans ' + comp.handle);
        });
        return false;
      }

      return actifs.every(function (comp) {
        var v = res.choix[comp.cle];
        if (!v) return false;
        return !estEpuise(v) && stockSuffisant(v, qteDe(comp));
      });
    }

    /**
     * Groupe de boutons de choix, sans intitulé.
     *
     * Extrait de blocChoix() à la passe 37 : la zone « Format et
     * langue du modèle » réunit sous un même intitulé une information
     * et un groupe de boutons, et n'a donc pas besoin du second
     * intitulé que blocChoix() poserait.
     *
     * `aria` porte ce que le groupe fait choisir, qui n'est pas
     * toujours l'intitulé affiché : sous « Format et langue du
     * modèle », les boutons ne choisissent que la langue.
     */
    /**
     * Nom d'un produit, en lien vers sa fiche.
     *
     * Rien ne signalait le lien : souligné, il se confond avec le
     * reste de la ligne, déjà en gris atténué. Une flèche sortante dit
     * à la fois « c'est cliquable » et « ça ouvre ailleurs ».
     *
     * Extrait de `rendreComposant()` à la passe 46 : les produits
     * additionnels portent le même lien, et deux copies du même tracé
     * SVG auraient divergé à la première retouche.
     */
    function lienProduit(titre, url) {
      var lien = el('a', 'lat-kit__lien', titre);
      lien.href = url;
      lien.target = '_blank';
      lien.rel = 'noopener';

      var fleche = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      fleche.setAttribute('viewBox', '0 0 14 14');
      fleche.setAttribute('aria-hidden', 'true');
      fleche.setAttribute('class', 'lat-kit__lien-icone');
      var trace = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      trace.setAttribute('d', 'M5.5 2.5h6v6M11.5 2.5L6 8M9 10.5v1h-7v-7h1');
      trace.setAttribute('fill', 'none');
      trace.setAttribute('stroke', 'currentColor');
      trace.setAttribute('stroke-width', '1.4');
      trace.setAttribute('stroke-linecap', 'round');
      trace.setAttribute('stroke-linejoin', 'round');
      fleche.appendChild(trace);
      lien.appendChild(fleche);

      return lien;
    }

    /**
     * Une pastille de variante — coloris de laine, ou déclinaison d'un
     * produit additionnel.
     *
     * Épuisé : non sélectionnable.
     * Insuffisant : sélectionnable, mais signalé par une pastille
     * chiffrée. On ne le désactive pas — le client doit pouvoir le
     * choisir puis changer de taille pour voir le problème disparaître,
     * ce qu'un bouton grisé sans explication empêcherait de comprendre.
     *
     * `courtBloquant` renverse cette dernière règle, et n'est vrai que
     * pour un produit additionnel : sa quantité est fixe, aucun geste
     * du client ne la ferait tenir dans le stock. Le badge chiffré
     * reste, il dit pourquoi le bouton ne répond pas.
     *
     * Extraite de `rendreComposant()` à la passe 46.
     */
    function pastilleVariante(v, besoin, actif, cle, onPick, courtBloquant) {
      var b = el('button', 'lat-kit__sw');
      b.type = 'button';
      b.setAttribute('data-cle', cle);
      b.title = v.titre + (v.dispo ? '' : ' \u2014 ' + S.indispo);
      b.setAttribute('aria-pressed', actif ? 'true' : 'false');

      if (v.img) {
        b.style.backgroundImage = 'url("' + v.img + '")';
      } else {
        b.classList.add('is-text');
        b.textContent = v.titre;
      }
      if (b.style.backgroundImage) {
        b.appendChild(el('span', 'lat-kit__sr', v.titre));
      }

      var epuise = estEpuise(v);
      var court = !epuise && !stockSuffisant(v, besoin);

      if (epuise) {
        b.classList.add('is-out');
        b.disabled = true;
        b.title = v.titre + ' \u2014 ' + S.indispo;
      } else if (court) {
        b.classList.add('is-short');
        b.title = v.titre + ' \u2014 ' + S.stock_court +
          ' (' + stockDe(v) + '/' + besoin + ')';
        b.appendChild(el('span', 'lat-kit__badge', String(stockDe(v))));
        if (courtBloquant) {
          b.classList.add('is-out');
          b.disabled = true;
        }
      }

      if (!b.disabled) b.addEventListener('click', onPick);
      return b;
    }

    function groupeChoix(items, onPick, aria) {
      var wrap = el('div', 'lat-kit__choices');
      wrap.setAttribute('role', 'group');
      wrap.setAttribute('aria-label', aria);
      items.forEach(function (it) {
        var b = el('button', 'lat-kit__choice');
        b.type = 'button';
        b.setAttribute('aria-pressed', it.actif ? 'true' : 'false');

        /* Vignette du colorway, quand le metafield en désigne une. Le
           libellé passe alors dans un <span> : en texte nu, il
           compterait pour un enfant de plus du conteneur en cases et
           s'en irait sous l'image, un mot par ligne. */
        if (it.img) {
          b.className = 'lat-kit__choice lat-kit__choice--img';
          var vue = document.createElement('img');
          vue.className = 'lat-kit__choice-vue';
          vue.src = it.img;
          vue.alt = '';
          vue.loading = 'lazy';
          b.appendChild(vue);
          b.appendChild(el('span', null, it.label));
        } else {
          b.textContent = it.label;
        }

        /* Repère stable d'un rendu à l'autre : c'est par lui que le
           focus retrouve son bouton après reconstruction du corps. */
        if (it.cle) b.setAttribute('data-cle', it.cle);
        b.addEventListener('click', function () { onPick(it.val); });
        wrap.appendChild(b);
      });
      return wrap;
    }

    /** Groupe de boutons de choix, précédé de son intitulé. */
    function blocChoix(titre, items, onPick) {
      var sec = el('div', 'lat-kit__section');
      sec.appendChild(el('div', 'lat-kit__label', titre));
      sec.appendChild(groupeChoix(items, onPick, titre));
      return sec;
    }

    /**
     * Le nom de la laine, en lien vers sa fiche, suivi de son métrage.
     *
     * Extrait de `rendreComposant()` à la passe 48 : un kit à coloris
     * imposés le pose une fois en tête de liste quand toutes ses
     * couleurs sortent du même produit, et deux copies du même
     * assemblage auraient divergé à la première retouche.
     */
    function ligneLaine(laine, classeEnPlus) {
      var d = el('div', 'lat-kit__comp-yarn' +
        (classeEnPlus ? ' ' + classeEnPlus : ''));
      d.appendChild(lienProduit(laine.titre, laine.url));
      if (laine.metrage) {
        d.appendChild(document.createTextNode(
          ' \u2014 ' + laine.metrage + ' ' +
          (laine.metrage_unite === 'YARDS' ? 'yd' : 'm')));
      }
      return d;
    }

    /**
     * Pelote de sécurité, choisie composant par composant : sur un
     * modèle à deux fils, le client peut vouloir se rassurer sur la
     * couleur dominante sans doubler la mise sur l'autre.
     *
     * Offerte aussi sur un kit à coloris imposés : elle porte sur une
     * quantité, pas sur une couleur, et rien dans le fait d'imposer
     * les coloris ne l'interdit. C'est au marchand de juger — sur un
     * jacquard à dix couleurs, dix cases seraient absurdes, et
     * `pelote_securite` reste alors à faux.
     */
    function caseSecurite(comp) {
      var lbl = el('label', 'lat-kit__secu');
      var cas = document.createElement('input');
      cas.type = 'checkbox';
      cas.setAttribute('data-cle', 'secu-' + comp.cle);
      cas.checked = !!etat.securite[comp.cle];
      cas.addEventListener('change', function () {
        if (cas.checked) etat.securite[comp.cle] = true;
        else delete etat.securite[comp.cle];
        rendre();
      });
      lbl.appendChild(cas);
      lbl.appendChild(el('span', null, S.securite));
      return lbl;
    }

    function rendreComposant(comp) {
      var laine = laines[comp.handle];
      var qte = qteDe(comp);
      var choisiTot = etat.choix[comp.cle];

      var box = el('div', 'lat-kit__comp');

      /* Aperçu du coloris retenu, à gauche du bloc.
         Toujours visible plutôt qu'au survol : sur mobile il n'y a pas
         de survol, et c'est justement là que les pastilles de 42 px
         sont les plus difficiles à départager.
         Tant que rien n'est choisi, la photo du produit tient la place
         et évite que la mise en page ne saute à la première sélection. */
      var vignette = el('div', 'lat-kit__vue');
      var vueImg = document.createElement('img');
      vueImg.className = 'lat-kit__vue-img';
      vueImg.alt = '';
      vueImg.loading = 'lazy';
      if (choisiTot && (choisiTot.img_l || choisiTot.img)) {
        vueImg.src = choisiTot.img_l || choisiTot.img;
        vueImg.alt = choisiTot.titre;
      } else if (laine.image) {
        vueImg.src = laine.image;
        vignette.className += ' is-attente';
      }
      if (vueImg.src) vignette.appendChild(vueImg);
      box.appendChild(vignette);

      var corpsComp = el('div', 'lat-kit__comp-corps');

      var tete = el('div', 'lat-kit__comp-head');
      tete.appendChild(el('span', 'lat-kit__comp-role', libelleRole(comp)));

      var libQte = el('span', 'lat-kit__comp-qty',
        qte + ' ' + (qte > 1 ? S.pelotes : S.pelote));
      if (etat.securite[comp.cle]) {
        /* Le client doit comprendre d'où vient la pelote supplémentaire :
           sans cette mention, la quantité affichée contredirait le patron. */
        libQte.appendChild(el('span', 'lat-kit__comp-dont',
          ' \u2014 ' + S.securite_dont));
      }
      tete.appendChild(libQte);
      corpsComp.appendChild(tete);

      corpsComp.appendChild(ligneLaine(laine));

      if (peloteSecurite && !modeleIndispo) {
        corpsComp.appendChild(caseSecurite(comp));
      }

      /* Rappel du coloris retenu. Tant qu'il n'y en a pas, la ligne
         reste VIDE mais présente : son « À choisir » n'apprenait rien
         qu'une rangée de pastilles ne dise déjà, et la retirer
         entièrement ferait glisser les pastilles sous le curseur au
         moment même où le client en clique une. */
      var sel = el('div', 'lat-kit__comp-sel');
      var choisi = etat.choix[comp.cle];
      if (choisi) {
        sel.appendChild(document.createTextNode(S.choix + ' : '));
        sel.appendChild(el('b', null, choisi.titre));
      }
      corpsComp.appendChild(sel);

      var wrap = el('div', 'lat-kit__swatches');
      wrap.setAttribute('role', 'group');
      wrap.setAttribute('aria-label', libelleRole(comp));

      /* Les règles de stock, d'accessibilité et d'image vivent dans
         `pastilleVariante()` depuis la passe 46 : les déclinaisons
         d'un produit additionnel s'affichent exactement pareil. */
      laine.variantes.forEach(function (v) {
        wrap.appendChild(pastilleVariante(
          v, qte,
          !!(choisi && choisi.id === v.id),
          'sw-' + comp.cle + '-' + v.id,
          function () {
            etat.choix[comp.cle] = v;
            if (etat.colorway) etat.colorwayDevie = true;
            rendre();
          },
          false
        ));
      });

      corpsComp.appendChild(wrap);
      box.appendChild(corpsComp);
      return box;
    }

    /**
     * Une ligne de composant dans un kit à COLORIS IMPOSÉS.
     *
     * Le client ne choisit pas, il lit : ni pastilles, ni rappel du
     * coloris retenu sur une ligne à part — le rôle et la couleur
     * tiennent sur la même, comme dans la table de laines d'un patron.
     *
     * `avecLaine` n'est vrai que si les couleurs viennent de plusieurs
     * produits : autrement la laine est nommée une fois, en tête de
     * liste, et la répéter noierait les coloris.
     *
     * Un coloris introuvable n'écrit RIEN à sa place. Le dire
     * « épuisé » serait faux — c'est une donnée fautive, pas un
     * stock — et l'encart « kit incomplet » l'a déjà nommé.
     */
    function rendreComposantFixe(comp, avecLaine) {
      var laine = laines[comp.handle];
      var v = etat.choix[comp.cle];
      var qte = qteDe(comp);

      var box = el('div', 'lat-kit__comp lat-kit__comp--fixe');

      var vignette = el('div', 'lat-kit__vue');
      var img = document.createElement('img');
      img.className = 'lat-kit__vue-img';
      img.alt = '';
      img.loading = 'lazy';
      if (v && (v.img_l || v.img)) {
        img.src = v.img_l || v.img;
        img.alt = v.titre;
      } else if (laine.image) {
        img.src = laine.image;
        vignette.className += ' is-attente';
      }
      if (img.src) vignette.appendChild(img);
      box.appendChild(vignette);

      var corpsComp = el('div', 'lat-kit__comp-corps');

      var tete = el('div', 'lat-kit__comp-head');
      var nom = el('span', 'lat-kit__fixe-role', libelleRole(comp));
      if (v) {
        nom.appendChild(document.createTextNode(' \u2014 '));
        nom.appendChild(el('b', null, v.titre));
      }
      tete.appendChild(nom);

      var libQte = el('span', 'lat-kit__comp-qty',
        qte + ' ' + (qte > 1 ? S.pelotes : S.pelote));
      if (etat.securite[comp.cle]) {
        libQte.appendChild(el('span', 'lat-kit__comp-dont',
          ' \u2014 ' + S.securite_dont));
      }
      /* Le stock court se dit sur la ligne, sans chiffre : l'alerte du
         pied porte le détail et la sortie de secours. Sans cette
         mention, la ligne paraîtrait commandable et le bouton grisé
         n'aurait pas d'explication à portée de regard. */
      if (v && !stockSuffisant(v, qte)) {
        libQte.appendChild(el('span', 'lat-kit__comp-dont',
          ' \u2014 ' + S.stock_court));
      }
      tete.appendChild(libQte);
      corpsComp.appendChild(tete);

      if (avecLaine) corpsComp.appendChild(ligneLaine(laine));
      if (peloteSecurite && !modeleIndispo) {
        corpsComp.appendChild(caseSecurite(comp));
      }

      box.appendChild(corpsComp);
      return box;
    }

    /**
     * Une ligne de produit additionnel, dans le corps du bloc.
     *
     * Même gabarit qu'un composant — vignette à gauche, corps à
     * droite — parce que c'est la même chose du point de vue du
     * client : un article du kit, avec une image et un prix. Ce qui
     * change tient à ce qu'un sac n'a pas : ni pelotes, ni métrage,
     * ni pelote de sécurité.
     */
    function rendreExtra(ex, idx) {
      var prod = laines[ex.handle];
      var qte = qteExtra(ex);
      var vs = variantesExtra(ex);
      var v = varianteExtra(ex, idx);
      var epuise = vs.length === 0;

      var box = el('div', 'lat-kit__comp');

      var vignette = el('div', 'lat-kit__vue');
      var img = document.createElement('img');
      img.className = 'lat-kit__vue-img';
      img.alt = '';
      img.loading = 'lazy';
      if (v && (v.img_l || v.img)) {
        img.src = v.img_l || v.img;
        img.alt = v.titre;
      } else if (prod.image) {
        img.src = prod.image;
        vignette.className += ' is-attente';
      }
      if (img.src) vignette.appendChild(img);
      box.appendChild(vignette);

      var corpsEx = el('div', 'lat-kit__comp-corps');

      var tete = el('div', 'lat-kit__comp-head');
      var nom = el('span', 'lat-kit__comp-role');
      nom.appendChild(lienProduit(prod.titre, prod.url));
      tete.appendChild(nom);

      /* À droite : la quantité s'il y en a plus d'une, puis ce que
         cette ligne coûte. */
      var droite = el('span', 'lat-kit__comp-qty');
      if (qte > 1) {
        droite.appendChild(el('span', null, '\u00d7 ' + qte + ' '));
      }
      if (epuise) {
        droite.appendChild(el('span', 'lat-kit__comp-dont', S.indispo));
      } else if (ex.offert === true) {
        droite.appendChild(el('b', 'lat-kit__offert', S.offert));
        /* La valeur barrée dit ce que le cadeau vaut. Elle n'est
           écrite que si une variante est retenue : sinon le prix
           affiché serait celui de la moins chère, donc faux dès que
           le client choisira. */
        if (v) {
          /* L'espace hors du barré : barrée, elle allongerait le
             trait d'un caractère avant le montant. */
          droite.appendChild(document.createTextNode(' '));
          droite.appendChild(el('span', 'lat-kit__recap-barre',
            prix(v.prix * qte)));
        }
      } else {
        droite.appendChild(el('span', null, prix(prixExtra(ex, idx))));
      }
      tete.appendChild(droite);
      corpsEx.appendChild(tete);

      /* Déclinaisons — seulement s'il y a réellement à choisir. Un
         produit à variante unique, ou dont le metafield impose la
         variante, n'affiche aucune pastille : un bouton seul
         n'offre pas un choix, il exige un clic. */
      if (vs.length > 1) {
        var sel = el('div', 'lat-kit__comp-sel');
        if (v) {
          sel.appendChild(el('span', null, S.choix + ' : '));
          sel.appendChild(el('b', null, v.titre));
        }
        corpsEx.appendChild(sel);

        var wrap = el('div', 'lat-kit__swatches');
        wrap.setAttribute('role', 'group');
        wrap.setAttribute('aria-label', prod.titre);

        /* Toutes les variantes, y compris celles qu'on ne peut pas
           prendre : un coloris grisé se comprend, un coloris absent
           fait croire qu'il n'a jamais existé. `courtBloquant` est
           vrai — la quantité d'un extra ne se négocie pas. */
        prod.variantes.forEach(function (candidate) {
          wrap.appendChild(pastilleVariante(
            candidate, qte,
            !!(v && v.id === candidate.id),
            'ex-' + idx + '-' + candidate.id,
            function () {
              etat.extras[idx] = candidate;
              rendre();
            },
            true
          ));
        });
        corpsEx.appendChild(wrap);
      } else if (v && prod.variantes.length > 1) {
        /* Variante MONTRÉE sans être choisie — la règle de la passe 39
           appliquée ici : masquer le BOUTON ne doit pas faire taire
           l'INFORMATION. Une variante imposée par le metafield, ou la
           seule encore achetable, n'offre aucun choix ; le client a
           pourtant le droit de savoir quelle taille d'aiguilles part
           avec son kit.

           `prod.variantes.length > 1` écarte le seul cas où l'écrire
           n'apprendrait rien : le « Default Title » que Shopify donne
           à la variante unique d'un produit sans options. */
        corpsEx.appendChild(el('div', 'lat-kit__comp-sel', v.titre));
      }

      box.appendChild(corpsEx);
      return box;
    }

    /**
     * Lignes de récapitulatif des produits additionnels.
     *
     * Partagées par le pied normal et le pied de rupture : sur un
     * modèle épuisé aussi, le client a le droit de savoir ce que le
     * kit coûtera à son retour.
     *
     * Un extra épuisé n'y figure pas — il ne sera pas facturé, et le
     * corps l'a déjà signalé.
     */
    function lignesRecapExtras() {
      return extrasActifs().map(function (e) {
        var prod = laines[e.ex.handle];
        var qte = qteExtra(e.ex);
        var ligne = el('div', 'lat-kit__recap-ligne');

        ligne.appendChild(el('span', null,
          prod.titre + (qte > 1 ? ' \u00d7 ' + qte : '')));

        if (e.ex.offert === true) {
          ligne.appendChild(el('span', 'lat-kit__offert', S.offert));
        } else {
          ligne.appendChild(el('span', null, prix(prixExtra(e.ex, e.idx))));
        }
        return ligne;
      });
    }

    /**
     * Résout un colorway sans rien modifier.
     * Renvoie les variantes trouvées et la liste des rôles pour
     * lesquels le coloris annoncé est introuvable — coloris supprimé
     * du produit, renommé, ou valeur erronée dans le metafield.
     */
    function resoudreColorway(cw, actifs) {
      var res = { choix: {}, manquants: [] };
      actifs.forEach(function (comp) {
        var valeur = cw.choix ? cw.choix[comp.cle] : null;
        if (!valeur) { res.manquants.push(comp); return; }
        var v = trouverVariante(laines[comp.handle].variantes, valeur);
        if (v) res.choix[comp.cle] = v;
        else res.manquants.push(comp);
      });
      return res;
    }

    /**
     * Applique un colorway.
     *
     * Un coloris introuvable EFFACE la sélection du composant au lieu
     * de la laisser en place. Sans quoi une valeur héritée d'un
     * colorway cliqué précédemment subsisterait, et le client croirait
     * la combinaison du créateur appliquée alors qu'une couleur ne
     * correspond pas.
     */
    function poserColorway(cw, actifs) {
      var res = resoudreColorway(cw, actifs);

      etat.colorway = cw.label;
      etat.colorwayDevie = false;
      etat.colorwayIncomplet = res.manquants.length > 0;

      actifs.forEach(function (comp) {
        if (res.choix[comp.cle]) etat.choix[comp.cle] = res.choix[comp.cle];
        else delete etat.choix[comp.cle];
      });

      /* Par `signaler()` plutôt que par un `console.warn` direct : un
         kit à coloris imposés repose son colorway à chaque rendu, et
         le même défaut de données s'écrirait à chaque clic. */
      res.manquants.forEach(function (comp) {
        signaler('cw-' + cw.label + '-' + comp.cle,
          'colorway "' + cw.label + '" : coloris "' +
          (cw.choix ? cw.choix[comp.cle] : '(non renseigné)') +
          '" introuvable dans ' + comp.handle +
          ' \u2014 sélection de "' + libelleRole(comp) + '" effacée');
      });
    }

    /** Applique un colorway et redessine. */
    function appliquerColorway(cw, actifs) {
      poserColorway(cw, actifs);
      rendre();
    }

    /**
     * Cale le colorway d'un kit à coloris imposés, et rend son rang.
     *
     * Reposé à CHAQUE rendu, et pas seulement au premier : un
     * changement de taille peut rendre requis un composant qui ne
     * l'était pas — une couleur d'accent à partir du L, ce que la
     * règle 9 autorise — et celui-là n'aurait jamais reçu son coloris.
     * Rien de ce que le client a fait ne s'y perd : sans déviation
     * possible, l'état ne porte que ce que le colorway a posé.
     */
    function calerColorway(cws, actifs) {
      var rang = 0, i;
      for (i = 0; i < cws.length; i++) {
        if (cws[i].label === etat.colorway) { rang = i; break; }
      }
      poserColorway(cws[rang], actifs);
      return rang;
    }

    /**
     * Pied de la formule « modèle seul ».
     *
     * Un seul article, donc pas de récapitulatif : la ligne de total
     * EST le récapitulatif, et en aligner deux qui portent le même
     * chiffre ne renseignerait personne.
     *
     * Le modèle déjà au panier ne se rachète pas — le bouton se
     * désactive et la note dit pourquoi. C'est le même principe que
     * la ligne barrée du pied du kit, réduit à ce qu'un article
     * unique permet.
     */
    function rendrePiedSeul() {
      var pied = el('div', 'lat-kit__foot');
      var deja = modeleAuPanier === true;

      var tot = el('div', 'lat-kit__total');
      tot.appendChild(el('span', null, S.total_modele));
      var montant = el('b', null, prix(prixModele()));
      if (deja) montant.className = 'lat-kit__recap-barre';
      tot.appendChild(montant);
      pied.appendChild(tot);

      pied.appendChild(el('div', 'lat-kit__taxes',
        taxesIncluses ? S.taxes_ttc : S.taxes_ht));

      var btn = el('button', 'lat-kit__add', S.ajouter_modele);
      btn.type = 'button';
      btn.setAttribute('data-cle', 'ajouter-modele');
      btn.disabled = deja;
      if (deja) btn.title = S.deja_panier;
      pied.appendChild(btn);

      var msg = el('div', 'lat-kit__msg');
      if (deja) {
        msg.className = 'lat-kit__msg';
        msg.innerHTML = esc(S.deja_panier) +
          ' \u2014 <a href="' + esc(racine() + 'cart') + '">' + esc(S.voir_panier) + '</a>';
      }
      pied.appendChild(msg);

      btn.addEventListener('click', function () {
        ajouterModeleSeul(btn, msg);
      });

      return pied;
    }

    /**
     * Pied d'une fiche dont le modèle est épuisé.
     *
     * Le pied ne disparaît pas : c'est lui qui ferme le bloc. Sans son
     * filet, le corps s'achèverait sur une rangée de pastilles, et
     * rien ne dirait au client si le bouton manque ou s'il est en
     * train de charger.
     *
     * Ce qui reste : le total de la laine, qui renseigne sans rien
     * promettre — le client sait ce que coûtera le kit à son retour.
     * Ce qui part : la ligne du modèle et le total du kit, qui
     * annonceraient un prix qu'on ne peut pas encaisser, et le bouton
     * d'ajout, qui n'a plus rien à ajouter.
     *
     * L'alerte de stock des laines part avec le reste : les pastilles
     * portent déjà leur badge chiffré, et il n'y a plus d'achat à
     * bloquer.
     */
    function rendrePiedRupture() {
      var pied = el('div', 'lat-kit__foot');

      var recap = el('div', 'lat-kit__recap');

      /* Les produits additionnels restent chiffrés, comme la laine :
         le client qui attend le retour du modèle sait ce que le kit
         complet lui coûtera. Seul le total du kit part, faute de
         pouvoir l'encaisser. */
      lignesRecapExtras().forEach(function (l) { recap.appendChild(l); });

      var ligne = el('div', 'lat-kit__recap-ligne');
      ligne.appendChild(el('span', null, S.total_laine));
      ligne.appendChild(el('span', null, prix(totalLaine())));
      recap.appendChild(ligne);
      pied.appendChild(recap);

      pied.appendChild(el('div', 'lat-kit__taxes',
        taxesIncluses ? S.taxes_ttc : S.taxes_ht));

      /* Deux clés distinctes, et non une phrase unique : la première
         dit l'état, la seconde ce qu'il reste possible. Seule la
         première est mise en avant. */
      var note = el('div', 'lat-kit__rupture');
      note.appendChild(el('b', null, S.rupture_titre));
      note.appendChild(document.createTextNode(' ' + S.rupture_aide));
      pied.appendChild(note);

      return pied;
    }

    function rendrePied() {
      var pied = el('div', 'lat-kit__foot');

      /* Récapitulatif détaillé : le client voit ce qu'il paiera
         réellement, modèle compris. La ligne du modèle disparaît s'il
         est déjà au panier — l'ajout ne le facturera pas deux fois. */
      var recap = el('div', 'lat-kit__recap');

      var pm = prixModele();
      if (pm > 0) {
        var lM = el('div', 'lat-kit__recap-ligne');
        var gM = el('span', null, S.total_modele);
        if (modeleAuPanier === true) {
          gM.appendChild(el('span', 'lat-kit__recap-note',
            ' \u2014 ' + S.deja_panier));
        }
        lM.appendChild(gM);
        var vM = el('span', null, prix(pm));
        if (modeleAuPanier === true) vM.className = 'lat-kit__recap-barre';
        lM.appendChild(vM);
        recap.appendChild(lM);
      }

      /* Les produits additionnels entre le modèle et la laine : les
         lignes fixes d'abord, et celle qui bouge au gré des choix du
         client juste au-dessus du total. */
      lignesRecapExtras().forEach(function (l) { recap.appendChild(l); });

      var lL = el('div', 'lat-kit__recap-ligne');
      lL.appendChild(el('span', null, S.total_laine));
      lL.appendChild(el('span', null, prix(totalLaine())));
      recap.appendChild(lL);

      pied.appendChild(recap);

      var tot = el('div', 'lat-kit__total');
      tot.appendChild(el('span', null, libelleTotal()));
      tot.appendChild(el('b', null, prix(totalKit())));
      pied.appendChild(tot);

      /* Les prix viennent tels quels de Shopify : ils portent déjà la
         devise et le régime de taxe du marché actif. `cart.taxes_included`
         dit lequel s'applique, ce qui varie d'un marché à l'autre quand la
         tarification TVA incluse dynamique est active. Autant l'écrire
         plutôt que de laisser le client deviner. */
      pied.appendChild(el('div', 'lat-kit__taxes',
        taxesIncluses ? S.taxes_ttc : S.taxes_ht));

      /* Blocage sur stock, avec le détail de ce qui manque.
         Un bouton grisé sans explication est la pire des réponses :
         le client ne sait pas quoi corriger. */
      var absents = composantsIndisponibles();
      var insuffisants = manques();
      if (insuffisants.length) {
        var alerte = el('div', 'lat-kit__alerte');
        alerte.appendChild(el('div', 'lat-kit__alerte-titre', S.stock_titre));
        var ul = el('ul', 'lat-kit__alerte-liste');
        insuffisants.forEach(function (m) {
          var li = el('li');
          li.appendChild(el('b', null, m.role));
          li.appendChild(document.createTextNode(
            ' \u2014 ' + m.coloris + ' : ' + m.dispo + ' / ' + m.besoin));

          /* Ce qu'il reste à faire, quand il reste quelque chose à
             faire. Sans issue, la ligne s'arrête sur les chiffres et
             c'est l'aide générale, en pied d'encart, qui parle. */
          var issue = null;
          if (m.securite) issue = S.stock_sans_securite;
          else if (m.tailles.length) {
            issue = S.stock_suffisant + ' ' + m.tailles.join(', ');
          }
          if (issue) {
            li.appendChild(el('span', 'lat-kit__alerte-aide',
              ' \u2014 ' + issue));
          }

          ul.appendChild(li);
        });
        alerte.appendChild(ul);
        /* « Choisissez un autre coloris, ou une autre taille » : la
           moitié de la phrase est fausse quand les coloris sont
           imposés. Elle disparaît alors entièrement plutôt que d'être
           réécrite — les sorties de secours par taille, elles, restent
           sur chaque ligne, et ce sont les seules qui existent. */
        if (!colorisImposes) {
          alerte.appendChild(el('div', 'lat-kit__alerte-aide', S.stock_aide));
        }
        pied.appendChild(alerte);
      }

      var btn = el('button', 'lat-kit__add', S.ajouter);
      btn.type = 'button';
      btn.setAttribute('data-cle', 'ajouter');
      btn.disabled = !toutChoisi() || insuffisants.length > 0 || absents.length > 0;
      pied.appendChild(btn);

      var msg = el('div', 'lat-kit__msg');
      pied.appendChild(msg);

      btn.addEventListener('click', function () {
        ajouterAuPanier(btn, msg);
      });

      return pied;
    }

    /* ---- Panier ---- */

    /**
     * Formulaire d'ajout au panier de CE produit, ou `null`.
     *
     * La résolution ne s'appuie sur aucune convention de thème. Elle
     * cherche d'abord le formulaire dont le champ [name="id"] porte une
     * variante de ce produit : c'est un signal certain, valable sous
     * Dawn, Symmetry, Horizon ou n'importe quel thème sur mesure.
     *
     * Les stratégies suivantes ne servent que si ce test échoue —
     * formulaire du produit dont le thème a vidé le champ. Elles ne
     * désignent jamais que ce produit-ci : l'identifiant déclaré,
     * l'enveloppe Dawn de la section, le formulaire qui englobe le bloc.
     *
     * AUCUN REPLI SUR LE PREMIER FORMULAIRE VENU — passe 53. Faute de
     * mieux, la fonction rendait jusque-là `formes[0]`. Sur une page
     * kit, où Buy buttons est retiré, c'était le formulaire d'une carte
     * de recommandation — Dawn en rend un par produit recommandé quand
     * l'ajout rapide est activé. Le bloc lisait alors la variante de ce
     * produit étranger, la mettait au panier À LA PLACE du patron,
     * sortait le livret du total, et désactivait le bouton de la carte.
     * Mieux vaut aucun formulaire qu'un faux : le bloc fait alors
     * choisir la version lui-même.
     */
    function formulaireProduit() {
      var formes = document.querySelectorAll('form[action*="/cart/add"]');
      var i, champ;

      // 1. Le formulaire porte une variante de ce produit
      for (i = 0; i < formes.length; i++) {
        champ = formes[i].querySelector('[name="id"]');
        if (champ && champ.value && modeleVariantes[String(champ.value)]) {
          return formes[i];
        }
      }

      // 2. Le formulaire déclare l'identifiant du produit
      var pid = bloc.getAttribute('data-product-id');
      for (i = 0; i < formes.length; i++) {
        if (formes[i].getAttribute('data-product-id') === pid) return formes[i];
      }

      // 3. Convention Dawn et dérivés
      var sid = bloc.getAttribute('data-section-id');
      if (sid) {
        var env = document.getElementById('product-form-' + sid);
        if (env) {
          var f = env.querySelector('form[action*="/cart/add"]');
          if (f) return f;
        }
      }

      // 4. Le formulaire qui englobe le bloc, s'il y en a un
      var parent = bloc.closest('form[action*="/cart/add"]');
      if (parent) return parent;

      return null;
    }

    /**
     * Variante que porte le formulaire du thème, si c'en est bien une
     * de CE modèle ; `null` sinon.
     *
     * Même le formulaire du produit peut porter un champ vide le temps
     * que le thème le remplisse. On ne lui fait donc confiance que sur
     * une variante connue — c'est aussi ce qui décide si le bloc laisse
     * le thème commander le choix de la version.
     */
    function varianteDuFormulaire() {
      var form = formulaireProduit();
      var champ = form ? form.querySelector('[name="id"]') : null;
      if (champ && champ.value && modeleVariantes[String(champ.value)]) {
        return parseInt(champ.value, 10);
      }
      return null;
    }

    /**
     * Écrit la variante retenue dans le `?variant=` de l'URL.
     *
     * Sur une page kit, aucun formulaire produit ne dit plus quelle
     * version est choisie — le bloc est seul à le savoir. Or le bloc
     * d'app d'alerte de retour en stock lit l'URL : sans ce reflet,
     * il proposerait de prévenir pour la variante par défaut et non
     * pour celle que le client regarde.
     *
     * `replaceState` et non `pushState` : choisir une version n'est
     * pas une navigation. Empiler des entrées d'historique obligerait
     * le client à cliquer « précédent » autant de fois qu'il a
     * hésité pour quitter la page.
     */
    function refleterVarianteDansUrl(id) {
      if (!window.history || !window.history.replaceState) return;
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', String(id));
        window.history.replaceState({}, '', u.toString());
        document.dispatchEvent(new CustomEvent('lat-kit:variant', {
          bubbles: true, detail: { id: id }
        }));
      } catch (err) { /* URL non supportée : sans gravité */ }
    }

    /**
     * Variante du modèle actuellement sélectionnée.
     *
     * Le paramètre ?variant= de l'URL n'est retenu qu'en dernier
     * recours, et seulement s'il correspond à une variante de ce
     * produit : sur une page qui en affiche plusieurs, il désignerait
     * sinon le mauvais.
     */
    function varianteModele() {
      var duTheme = varianteDuFormulaire();
      if (duTheme !== null) return duTheme;

      /* Sélecteur du bloc : consulté après le formulaire, jamais
         avant. Si le thème en expose un, c'est lui qui fait foi —
         sinon le récapitulatif afficherait une variante et le panier
         en recevrait une autre. */
      if (varianteChoisie && modeleVariantes[String(varianteChoisie)]) {
        return varianteChoisie;
      }

      var url = new URL(window.location.href).searchParams.get('variant');
      if (url && modeleVariantes[String(url)]) return parseInt(url, 10);

      /* Modèle sans déclinaison : sa variante unique est la seule
         entrée de la carte. */
      var cles = Object.keys(modeleVariantes);
      if (cles.length === 1) return parseInt(cles[0], 10);

      return null;
    }

    /**
     * Le modèle est-il DÉJÀ au panier hors kit ?
     *
     * Le bloc cohabite avec le bouton « Ajouter au panier » du thème.
     * Un client peut donc ajouter le modèle seul, puis cocher la case
     * et ajouter la laine — ce qui ajouterait le modèle une seconde
     * fois. On interroge le panier pour ne l'ajouter que s'il n'y est
     * pas déjà.
     *
     * En cas d'échec de la requête, on renvoie `false` : mieux vaut un
     * doublon visible et corrigeable qu'un modèle manquant.
     */
    function modeleDejaAuPanier(idVariante) {
      return fetch(racine() + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (panier) {
          return (panier.items || []).some(function (it) {
            return it.variant_id === idVariante;
          });
        })
        .catch(function () { return false; });
    }

    /**
     * Poste des articles sur /cart/add.js et rend compte au client.
     *
     * Écrit une seule fois parce que deux formules l'empruntent — le
     * kit et le modèle seul. Les faire diverger, c'est se retrouver
     * avec un message d'erreur traduit d'un côté et pas de l'autre.
     *
     * `libelleRepos` est le texte à remettre sur le bouton si l'ajout
     * échoue : il n'est pas le même selon la formule.
     */
    function envoyerAuPanier(items, btn, msg, libelleRepos, detail) {
      btn.disabled = true;
      btn.textContent = S.ajout_cours;
      msg.textContent = '';
      msg.className = 'lat-kit__msg';

      return fetch(racine() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (d) { throw d; });
          return r.json();
        })
        .then(function (data) {
          btn.textContent = S.ajoute;
          msg.className = 'lat-kit__msg is-ok';
          msg.innerHTML = esc(S.ajoute) +
            ' \u2014 <a href="' + esc(racine() + 'cart') + '">' + esc(S.voir_panier) + '</a>';

          /* Événements de rafraîchissement du panier.
             `lat-kit:added` est propre au bloc ; les autres sont les
             conventions les plus répandues (Dawn et dérivés, dont
             Symmetry). Aucune redirection forcée : si le thème gère un
             tiroir de panier, il s'ouvre ; sinon le client dispose du
             lien ci-dessus. */
          modeleAuPanier = true;

          [['lat-kit:added', detail],
           ['cart:refresh', {}],
           ['cart:build', {}]].forEach(function (p) {
            document.dispatchEvent(new CustomEvent(p[0], {
              bubbles: true, detail: p[1]
            }));
          });
          if (window.Shopify && window.Shopify.onCartUpdate) {
            try { window.Shopify.onCartUpdate(data); } catch (e) {}
          }
        })
        .catch(function (err) {
          btn.disabled = false;
          btn.textContent = libelleRepos;
          msg.className = 'lat-kit__msg is-err';
          msg.textContent = (err && err.description) ? err.description : S.erreur;
          if (window.console) console.error('[lat-kit] /cart/add.js', err);
        });
    }

    /**
     * Ajout de la formule « modèle seul ».
     *
     * Aucune propriété de ligne : ce n'est pas un kit, et `_kit_id`
     * ferait croire au préparateur qu'une laine doit suivre.
     */
    function ajouterModeleSeul(btn, msg) {
      if (modeleIndispo || laineObligatoire) return;
      var id = varianteModele();
      if (!id) {
        msg.className = 'lat-kit__msg is-err';
        msg.textContent = S.erreur;
        if (window.console) {
          console.warn('[lat-kit] variante du modèle introuvable');
        }
        return;
      }
      var items = [{ id: id, quantity: 1 }];
      envoyerAuPanier(items, btn, msg, S.ajouter_modele,
        { seul: true, items: items });
    }

    function ajouterAuPanier(btn, msg) {
      var actifs = composantsActifs();
      if (!actifs.length || !toutChoisi()) return;
      if (manques().length) return;              // bouton déjà désactivé
      if (composantsIndisponibles().length) return;
      if (modeleIndispo) return;                 // pied de rupture, aucun bouton

      var taille = kit.tailles[etat.tailleIdx];
      var titreModele = bloc.getAttribute('data-product-title') || '';
      var handleModele = bloc.getAttribute('data-product-handle') || '';
      var libelleKit = titreModele + ' \u2014 ' + taille;
      var kitId = 'kit-' + Date.now() + '-' +
        Math.random().toString(36).slice(2, 6);

      // Les laines
      /* L'étiquette doit refléter ce que le client a réellement
         retenu. Un colorway dont un coloris manquait a forcément été
         complété à la main : le signaler évite de faire croire au
         préparateur, ou au SAV, que la combinaison du créateur a été
         suivie telle quelle. */
      var suffixe = '';
      if (etat.colorwayDevie) suffixe = ' \u2014 ' + S.colorway_modifie;
      else if (etat.colorwayIncomplet) suffixe = ' \u2014 ' + S.colorway_complete;
      var labelCw = etat.colorway ? (etat.colorway + suffixe) : null;

      /* `_kit_id`, `_kit_cle` et `_kit_modele` sont lus au paiement
         par la règle du dépôt lat-kit-validation (passe 55) : une
         ligne de laine s'y reconnaît à `_kit_cle`, et se rattache au
         modèle par `_kit_id` ou `_kit_modele`. Renommer l'une d'elles
         ici ferait refuser toute commande de kit à laine obligatoire —
         la modification se reporte dans les deux dépôts. */
      var itemsLaine = actifs.map(function (comp) {
        var v = etat.choix[comp.cle];
        var props = {
          'Kit': libelleKit,
          'Role': libelleRole(comp),
          '_kit_id': kitId,
          '_kit_cle': comp.cle,
          '_kit_modele': handleModele
        };
        if (labelCw) props['Colorway'] = labelCw;
        return { id: v.id, quantity: qteDe(comp), properties: props };
      });

      /* Les produits additionnels — passe 46.

         Ni `Role` ni `_kit_cle` : c'est précisément leur absence qui
         distingue, à l'export comme à la préparation, une ligne
         d'accessoire d'une ligne de laine. Inutile d'ajouter une
         propriété pour dire ce que deux autres disent déjà.

         `_kit_offert` dit au préparateur et au SAV que cette ligne
         doit être à zéro, et sert de repère au contrôle posé juste
         après l'ajout. */
      var itemsExtra = [];
      extrasActifs().forEach(function (e) {
        var vExtra = varianteExtra(e.ex, e.idx);
        if (!vExtra) return;          // choix en attente, bouton déjà bloqué
        var propsExtra = {
          'Kit': libelleKit,
          '_kit_id': kitId,
          '_kit_modele': handleModele
        };
        if (e.ex.offert === true) propsExtra['_kit_offert'] = '1';
        itemsExtra.push({
          id: vExtra.id,
          quantity: qteExtra(e.ex),
          properties: propsExtra
        });
      });

      /* Désactivé dès maintenant, et non par envoyerAuPanier() :
         l'interrogation du panier ci-dessous prend un aller-retour,
         pendant lequel un double clic partirait deux fois. */
      btn.disabled = true;
      btn.textContent = S.ajout_cours;
      msg.textContent = '';
      msg.className = 'lat-kit__msg';

      var idModele = varianteModele();
      var prealable = idModele
        ? modeleDejaAuPanier(idModele)
        : Promise.resolve(true);

      prealable.then(function (dejaLa) {
        var items = itemsLaine.concat(itemsExtra);
        if (idModele && !dejaLa) {
          // Le modèle en tête : il apparaît en premier au panier.
          items.unshift({
            id: idModele,
            quantity: 1,
            properties: {
              'Kit': libelleKit,
              'Size': taille,
              '_kit_id': kitId
            }
          });
        }
        return envoyerAuPanier(items, btn, msg, S.ajouter,
          { kitId: kitId, items: items })
          .then(function () {
            /* Un aller-retour de plus n'a de sens que s'il y a quelque
               chose à contrôler : sans article offert, rien ne peut
               diverger. */
            var aOffert = itemsExtra.some(function (it) {
              return it.properties._kit_offert === '1';
            });
            if (aOffert) verifierOfferts(kitId);
          });
      });
    }

    /**
     * Un article annoncé « offert » a-t-il bien été ramené à zéro ?
     *
     * `offert` n'est qu'un affichage : /cart/add.js ne peut pas
     * imposer un prix, seul le moteur de remises de Shopify le peut.
     * C'est donc une REMISE AUTOMATIQUE « Acheter X, obtenir Y » à
     * 100 % qui rend l'article gratuit — et elle vit dans l'admin,
     * hors du dépôt. Rien ne relie le drapeau du metafield à son
     * existence : si elle manque, a expiré, ou ne couvre pas ce
     * panier, le bloc annonce un cadeau que la caisse facture.
     *
     * Le contrôle ne répare rien et ne dit rien au client : il est
     * trop tard, et l'alarmer sur une erreur de configuration
     * n'aiderait personne. Il rend la panne visible au PREMIER essai,
     * dans la console, là où le marchand et le développeur regardent —
     * plutôt que sur une commande, trois semaines plus tard.
     *
     * Le panier est relu plutôt que la réponse de /cart/add.js : les
     * remises se calculent sur le panier entier, et c'est /cart.js
     * qui en porte le résultat à coup sûr.
     */
    function verifierOfferts(kitId) {
      fetch(racine() + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (panier) {
          (panier.items || []).forEach(function (it) {
            var props = it.properties || {};
            if (props._kit_id !== kitId) return;
            if (props._kit_offert !== '1') return;
            if (!it.final_line_price) return;      // bien à zéro
            if (window.console) {
              console.warn('[lat-kit] « ' + it.title + ' » est annoncé offert, ' +
                'mais le panier le facture (' + it.final_line_price +
                ' centimes). La remise automatique Shopify est absente, expirée, ' +
                'ou ne couvre pas ce panier — voir docs/02-deploiement.md § A5septies.');
            }
          });
        })
        .catch(function () { /* sans réponse, rien à affirmer */ });
    }

    /* ==========================================================
       Laine obligatoire

       Quand le metafield porte `laine_obligatoire: true`, le modèle
       n'est pas censé être vendu seul. Le bloc affiche la raison et
       désactive le bouton d'ajout du thème, s'il en reste un.

       La raison s'écrit dans `dessiner()`, sous le format et la langue
       du livret — voir la note `lat-kit__obligatoire` là-bas. Ne
       subsiste ici que la barrière, qui ne touche pas au corps.

       Depuis que la page kit est le seul chemin d'achat — bouton natif
       et sélecteur de quantité retirés dans l'éditeur de thème — cette
       désactivation ne trouve en général plus rien à désactiver. Elle
       est conservée pour les fiches où le bouton natif subsiste, et
       pour les thèmes qui le réinjectent après coup.

       Elle est suspendue quand le modèle est épuisé — voir plus bas :
       le bouton du thème est alors le point d'ancrage de l'app
       d'alerte de retour en stock.

       PORTÉE. C'est une barrière d'interface, pas une garantie. Un
       permalien, un ajout rapide depuis une page collection, un
       appel direct à /cart/add.js la contournent — et le panier
       lui-même, où le client peut retirer la laine après un ajout
       en règle : arrivé en production le 27/09/2026. Le seul filet
       réel est la règle au paiement du dépôt lat-kit-validation
       (docs/02 § A5ter, passe 55) — celle-ci lui évite d'avoir à se
       déclencher, ce qui vaut mieux pour le client que de découvrir
       le refus au moment de payer.
       ========================================================== */
    /**
     * Neutralise le bouton d'ajout du thème, s'il en reste un.
     *
     * SAUF SUR UNE FICHE ÉPUISÉE. La note reste — le modèle continue
     * de ne pas se vendre seul — mais le bouton du thème est laissé
     * intact : c'est sur lui que les apps d'alerte greffent leur
     * « Prévenez-moi », et il n'y a de toute façon plus rien à
     * empêcher d'acheter. Le désactiver là reviendrait à refaire,
     * autrement, le défaut que la passe 34 corrige.
     *
     * RÉAPPLIQUABLE, et c'est le point. Les thèmes dérivés de Dawn
     * font l'inverse à chaque changement de variante : ils
     * RÉACTIVENT le bouton dès que la variante est disponible. Une
     * désactivation posée une fois au chargement ne survivait donc
     * pas au premier changement de langue. Les boutons de paiement
     * express, injectés par Shopify après coup, échappaient de même à
     * une passe unique.
     *
     * Le garde `b.disabled` évite de réécrire un attribut déjà posé —
     * sans lui, l'observateur qui appelle cette fonction se
     * réveillerait sur ses propres écritures.
     */
    function appliquerBarriere() {
      if (!laineObligatoire || modeleIndispo) return;
      var formTheme = formulaireProduit();
      if (!formTheme) return;
      formTheme.querySelectorAll(
        '[type="submit"], button[name="add"], .shopify-payment-button button'
      ).forEach(function (b) {
        if (b.disabled) return;
        b.disabled = true;
        b.setAttribute('aria-disabled', 'true');
        b.title = S.obligatoire;
      });
    }

    /* ==========================================================
       Écouteurs de page, et leur retrait — passe 53

       Le bloc écoute la page entière : changements de variante et de
       panier, retour arrière, formulaire du thème. Quand le thème le
       remplace — rechargement de section, quick-view, éditeur —,
       l'ancienne instance restait abonnée : ce fichier ne contenait
       aucun `removeEventListener`. Mesuré après cinq remplacements :
       un seul `cart:refresh` déclenchait six lectures du panier.

       Chaque écouteur de page passe donc par `ecouter()` ou
       `observer()`, et commence par `horsPage()`. Au premier événement
       que reçoit un bloc sorti du document, l'instance retire tous ses
       écouteurs et débranche ses observateurs. Elle rend aussi son
       drapeau `data-lat-kit-pret` : si le thème remettait un jour ce
       même nœud dans la page, il serait initialisé à neuf plutôt que
       laissé sourd.
       ========================================================== */
    var ecouteurs = [];
    var observateurs = [];

    function ecouter(cible, type, fn) {
      cible.addEventListener(type, fn);
      ecouteurs.push([cible, type, fn]);
    }

    function observer(noeud, reglages, fn) {
      if (!window.MutationObserver) return;
      var o = new MutationObserver(fn);
      o.observe(noeud, reglages);
      observateurs.push(o);
    }

    function horsPage() {
      if (document.documentElement.contains(bloc)) return false;
      ecouteurs.forEach(function (x) { x[0].removeEventListener(x[1], x[2]); });
      observateurs.forEach(function (o) { o.disconnect(); });
      ecouteurs = [];
      observateurs = [];
      bloc.removeAttribute('data-lat-kit-pret');
      return true;
    }

    if (laineObligatoire) {
      bloc.classList.add('lat-kit--obligatoire');

      appliquerBarriere();

      var formBarriere = modeleIndispo ? null : formulaireProduit();
      if (formBarriere) {
        observer(formBarriere, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['disabled']
        }, function () {
          if (!horsPage()) appliquerBarriere();
        });
      }
    }

    /* ==========================================================
       Suivi de la variante du modèle

       Un modèle peut être décliné — par langue, typiquement — et ces
       variantes n'ont pas forcément le même prix. Sans ce suivi, le
       récapitulatif garderait le prix de la variante affichée à
       l'ouverture du bloc, et l'état « déjà au panier » porterait sur
       la mauvaise variante.

       L'ajout au panier, lui, a toujours été correct : il relit le
       formulaire au moment du clic. C'était donc un décalage
       d'affichage, pas une erreur de commande.

       Le champ [name="id"] est parfois remplacé par le thème plutôt
       que modifié — Symmetry le fait via data-dynamic-variant-content.
       On combine donc trois filets : écoute déléguée sur le
       formulaire, observation du champ, et événements de thème.
       ========================================================== */
    (function suivreVarianteModele() {
      var dernier = varianteModele();

      function verifier() {
        if (horsPage()) return;
        var courant = varianteModele();
        if (courant === dernier) return;
        dernier = courant;
        modeleAuPanier = null;          // l'état porte sur l'ancienne variante
        rendre();
        rafraichirEtatPanier();
        appliquerBarriere();            // le thème vient peut-être de la lever
      }

      var form = formulaireProduit();

      ecouter(form || document, 'change', function (e) {
        if (horsPage()) return;
        var t = e.target;
        if (t && t.matches && t.matches('[name="id"]')) setTimeout(verifier, 10);
      });

      if (form) {
        form.querySelectorAll('[name="id"]').forEach(function (champ) {
          observer(champ, { attributes: true, attributeFilter: ['value'] }, function () {
            if (!horsPage()) setTimeout(verifier, 10);
          });
        });
      }

      ['variant:change', 'product:variant-change', 'theme:variant:change']
        .forEach(function (ev) {
          ecouter(document, ev, function () {
            if (!horsPage()) setTimeout(verifier, 10);
          });
        });

      ecouter(window, 'popstate', function () {
        if (!horsPage()) setTimeout(verifier, 10);
      });

      /* Sélecteurs qui remplacent l'id sans émettre `change`. */
      ecouter(form || document, 'click', function (e) {
        if (horsPage()) return;
        if (e.target.closest && e.target.closest('[data-variant-id], [data-option-value]')) {
          setTimeout(verifier, 120);
          setTimeout(verifier, 350);
        }
      });
    })();

    /* ==========================================================
       Le panier peut changer sans passer par le bloc

       Le modèle reste achetable ailleurs : par la formule « modèle
       seul », par le bouton du thème là où il subsiste, par une page
       collection ou un tiroir de panier. Sans le savoir, le bloc
       annonce un total qui compte un article déjà au panier.

       La mécanique d'affichage existait depuis toujours — ligne
       barrée, mention « déjà au panier », total qui l'exclut — il lui
       manquait un déclencheur. Ces noms d'événements sont les
       conventions les plus répandues, celles-là mêmes que le bloc
       émet après ses propres ajouts.

       Aucune boucle : rafraichirEtatPanier() n'émet rien et ne
       re-rend que si l'état a réellement changé.

       Une seule lecture par salve — passe 53. Ces événements arrivent
       souvent groupés : le bloc en émet lui-même deux après chaque
       ajout, `cart:refresh` et `cart:build`, et un thème en ajoute
       parfois un troisième. Chacun relisait le panier.
       ========================================================== */
    var lecturePrevue = null;

    function planifierLecturePanier() {
      if (lecturePrevue) clearTimeout(lecturePrevue);
      lecturePrevue = setTimeout(function () {
        lecturePrevue = null;
        rafraichirEtatPanier();
      }, 80);
    }

    ['cart:refresh', 'cart:build', 'cart:updated', 'cart:change',
     'shopify:cart:update'].forEach(function (ev) {
      ecouter(document, ev, function () {
        if (!horsPage()) planifierLecturePanier();
      });
    });

    /* Retour par le bouton « précédent » : la page sort du cache du
       navigateur telle qu'elle était, panier compris.

       Ce retour-là seulement : `pageshow` se déclenche aussi au
       chargement ordinaire, et relisait alors le panier une seconde
       fois, juste après la lecture d'ouverture ci-dessous. */
    ecouter(window, 'pageshow', function (e) {
      if (horsPage()) return;
      if (e && e.persisted) rafraichirEtatPanier();
    });

    /* Le bloc porte l'achat de la page — seul, ou aux côtés du bouton
       du thème quand le marchand l'a conservé. Il s'affiche d'emblée,
       sans case à cocher préalable. */
    rendre();
    rafraichirEtatPanier();
  }

  function init() {
    var blocs = document.querySelectorAll('[data-lat-kit]');
    if (!blocs.length) return;
    Array.prototype.forEach.call(blocs, initBloc);
  }

  /* Réinitialisation si le thème remplace le bloc (option
     « Update when variant changes » d'un bloc Custom Liquid,
     quick-view injectée, rechargement de section dans l'éditeur). */
  if (!window.__latKitObserve && window.MutationObserver && document.body) {
    window.__latKitObserve = true;
    var planifie = false;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var aj = muts[i].addedNodes;
        for (var j = 0; j < aj.length; j++) {
          var n = aj[j];
          if (n.nodeType !== 1) continue;
          if ((n.matches && n.matches('[data-lat-kit]')) ||
              (n.querySelector && n.querySelector('[data-lat-kit]'))) {
            if (planifie) return;
            planifie = true;
            setTimeout(function () { planifie = false; init(); }, 20);
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:section:load', function () {
    setTimeout(init, 10);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
